/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./../routes/__root";
import { Route as OnboardingRouteImport } from "./../routes/onboarding";
import { Route as MagicLinkRouteImport } from "./../routes/magic-link";
import { Route as No_authRouteImport } from "./../routes/_no_auth";
import { Route as AuthRouteImport } from "./../routes/_auth";
import { Route as No_authSignUpRouteImport } from "./../routes/_no_auth/sign-up";
import { Route as No_authSignInRouteImport } from "./../routes/_no_auth/sign-in";
import { Route as No_authResetPasswordRouteImport } from "./../routes/_no_auth/reset-password";
import { Route as AuthProjectRouteImport } from "./../routes/_auth/_project";
import { Route as AuthOrganisationRouteImport } from "./../routes/_auth/_organisation";
import { Route as AuthFrameRouteImport } from "./../routes/_auth/_frame";
import { Route as AuthDealRouteImport } from "./../routes/_auth/_deal";
import { Route as AuthFrameIndexRouteImport } from "./../routes/_auth/_frame/index";
import { Route as No_authSsoErrorSplatRouteImport } from "./../routes/_no_auth/sso-error/$";
import { Route as AuthOrganisationOrganisationRouteImport } from "./../routes/_auth/_organisation/organisation";
import { Route as AuthFrameWelcomeRouteImport } from "./../routes/_auth/_frame/welcome";
import { Route as AuthFrameSuppliersRouteImport } from "./../routes/_auth/_frame/suppliers";
import { Route as AuthFrameStorybookRouteImport } from "./../routes/_auth/_frame/storybook";
import { Route as AuthFrameSteeringRouteImport } from "./../routes/_auth/_frame/steering";
import { Route as AuthFrameLibraryRouteImport } from "./../routes/_auth/_frame/library";
import { Route as AuthFrameKaraokeRouteImport } from "./../routes/_auth/_frame/karaoke";
import { Route as AuthFrameClientsRouteImport } from "./../routes/_auth/_frame/clients";
import { Route as AuthFrameAbacusRouteImport } from "./../routes/_auth/_frame/abacus";
import { Route as AuthOrganisationOrganisationIndexRouteImport } from "./../routes/_auth/_organisation/organisation/index";
import { Route as AuthFrameTendersIndexRouteImport } from "./../routes/_auth/_frame/tenders/index";
import { Route as AuthFrameSuppliersIndexRouteImport } from "./../routes/_auth/_frame/suppliers/index";
import { Route as AuthFrameStorybookIndexRouteImport } from "./../routes/_auth/_frame/storybook/index";
import { Route as AuthFrameDealsIndexRouteImport } from "./../routes/_auth/_frame/deals/index";
import { Route as AuthFrameClientsIndexRouteImport } from "./../routes/_auth/_frame/clients/index";
import { Route as AuthFrameChronoDevisIndexRouteImport } from "./../routes/_auth/_frame/chrono-devis/index";
import { Route as AuthFrameAdminIndexRouteImport } from "./../routes/_auth/_frame/admin/index";
import { Route as AuthOrganisationOrganisationResourcesRouteImport } from "./../routes/_auth/_organisation/organisation/resources";
import { Route as AuthOrganisationOrganisationQuoteCreationRouteImport } from "./../routes/_auth/_organisation/organisation/quote-creation";
import { Route as AuthOrganisationOrganisationMembersRouteImport } from "./../routes/_auth/_organisation/organisation/members";
import { Route as AuthOrganisationOrganisationExportsRouteImport } from "./../routes/_auth/_organisation/organisation/exports";
import { Route as AuthOrganisationOrganisationCompanyInformationRouteImport } from "./../routes/_auth/_organisation/organisation/company-information";
import { Route as AuthFrameSuppliersContactsRouteImport } from "./../routes/_auth/_frame/suppliers/contacts";
import { Route as AuthFrameSuppliersSupplierIdRouteImport } from "./../routes/_auth/_frame/suppliers.$supplierId";
import { Route as AuthFrameStorybookContentLayoutRouteImport } from "./../routes/_auth/_frame/storybook/content-layout";
import { Route as AuthFrameClientsContactsRouteImport } from "./../routes/_auth/_frame/clients/contacts";
import { Route as AuthFrameClientsCompanyIdRouteImport } from "./../routes/_auth/_frame/clients.$companyId";
import { Route as AuthFrameChronoDevisInternalTrackingRouteImport } from "./../routes/_auth/_frame/chrono-devis/internal-tracking";
import { Route as AuthFrameAdminMailTestRouteImport } from "./../routes/_auth/_frame/admin/mail-test";
import { Route as AuthDealDealsDealIdRouteImport } from "./../routes/_auth/_deal/deals/$dealId";
import { Route as AuthProjectBidProjectIdIndexRouteImport } from "./../routes/_auth/_project/bid.$projectId.index";
import { Route as AuthOrganisationOrganisationResourcesIndexRouteImport } from "./../routes/_auth/_organisation/organisation/resources/index";
import { Route as AuthOrganisationOrganisationExportsIndexRouteImport } from "./../routes/_auth/_organisation/organisation/exports/index";
import { Route as AuthFrameSuppliersSupplierIdIndexRouteImport } from "./../routes/_auth/_frame/suppliers.$supplierId/index";
import { Route as AuthFrameClientsCompanyIdIndexRouteImport } from "./../routes/_auth/_frame/clients.$companyId/index";
import { Route as AuthDealDealsDealIdIndexRouteImport } from "./../routes/_auth/_deal/deals/$dealId/index";
import { Route as AuthProjectTasksProjectIdSubProjectIdRouteImport } from "./../routes/_auth/_project/tasks.$projectId.$subProjectId";
import { Route as AuthProjectSupplierQuoteRequestProjectIdSubProjectIdRouteImport } from "./../routes/_auth/_project/supplier-quote-request.$projectId.$subProjectId";
import { Route as AuthProjectSummaryProjectIdSubProjectIdRouteImport } from "./../routes/_auth/_project/summary.$projectId.$subProjectId";
import { Route as AuthProjectPurchasesProjectIdSubProjectIdRouteImport } from "./../routes/_auth/_project/purchases.$projectId.$subProjectId";
import { Route as AuthProjectMarginOptimizationProjectIdSubProjectIdRouteImport } from "./../routes/_auth/_project/margin-optimization.$projectId.$subProjectId";
import { Route as AuthProjectIndirectCostsProjectIdSubProjectIdRouteImport } from "./../routes/_auth/_project/indirect-costs.$projectId.$subProjectId";
import { Route as AuthProjectImportProjectIdSubProjectIdRouteImport } from "./../routes/_auth/_project/import.$projectId.$subProjectId";
import { Route as AuthProjectBidProjectIdSubProjectIdRouteImport } from "./../routes/_auth/_project/bid.$projectId.$subProjectId";
import { Route as AuthProjectBidRowDetailsProjectIdSubProjectIdRouteImport } from "./../routes/_auth/_project/bid-row-details.$projectId.$subProjectId";
import { Route as AuthProjectProjectIdSubProjectIdSdpConfigRouteImport } from "./../routes/_auth/_project/$projectId.$subProjectId.sdp-config";
import { Route as AuthProjectProjectIdSubProjectIdSdpRouteImport } from "./../routes/_auth/_project/$projectId.$subProjectId.sdp";
import { Route as AuthProjectProjectIdSubProjectIdExportQuoteRouteImport } from "./../routes/_auth/_project/$projectId.$subProjectId.export-quote";
import { Route as AuthOrganisationOrganisationResourcesTravelCostsRouteImport } from "./../routes/_auth/_organisation/organisation/resources/travel-costs";
import { Route as AuthOrganisationOrganisationResourcesSupplyFamiliesRouteImport } from "./../routes/_auth/_organisation/organisation/resources/supply-families";
import { Route as AuthOrganisationOrganisationResourcesSubcontractingRouteImport } from "./../routes/_auth/_organisation/organisation/resources/subcontracting";
import { Route as AuthOrganisationOrganisationResourcesOtherCostsRouteImport } from "./../routes/_auth/_organisation/organisation/resources/other-costs";
import { Route as AuthOrganisationOrganisationResourcesLaborRouteImport } from "./../routes/_auth/_organisation/organisation/resources/labor";
import { Route as AuthOrganisationOrganisationResourcesEquipmentRouteImport } from "./../routes/_auth/_organisation/organisation/resources/equipment";
import { Route as AuthOrganisationOrganisationResourcesAdditionalCostsRouteImport } from "./../routes/_auth/_organisation/organisation/resources/additional-costs";
import { Route as AuthOrganisationOrganisationExportsQuoteLayoutRouteImport } from "./../routes/_auth/_organisation/organisation/exports/quote-layout";
import { Route as AuthOrganisationOrganisationExportsPriceBreakdownCoefficientsRouteImport } from "./../routes/_auth/_organisation/organisation/exports/price-breakdown-coefficients";
import { Route as AuthFrameSuppliersSupplierIdPricedDeliverablesRouteImport } from "./../routes/_auth/_frame/suppliers.$supplierId/priced-deliverables";
import { Route as AuthFrameSuppliersSupplierIdImportedCatalogRouteImport } from "./../routes/_auth/_frame/suppliers.$supplierId/imported-catalog";
import { Route as AuthFrameSuppliersSupplierIdContactsRouteImport } from "./../routes/_auth/_frame/suppliers.$supplierId/contacts";
import { Route as AuthFrameSuppliersSupplierIdCatalogPricesRouteImport } from "./../routes/_auth/_frame/suppliers.$supplierId/catalog-prices";
import { Route as AuthFrameClientsCompanyIdProjectsRouteImport } from "./../routes/_auth/_frame/clients.$companyId/projects";
import { Route as AuthFrameClientsCompanyIdContactsRouteImport } from "./../routes/_auth/_frame/clients.$companyId/contacts";
import { Route as AuthDealDealsDealIdQuotesRouteImport } from "./../routes/_auth/_deal/deals/$dealId/quotes";
import { Route as AuthDealDealsDealIdContractualInformationRouteImport } from "./../routes/_auth/_deal/deals/$dealId/contractual-information";
import { Route as AuthDealDealsDealIdClientPricingDocumentRouteImport } from "./../routes/_auth/_deal/deals/$dealId/client-pricing-document";
import { Route as AuthDealDealsDealIdAnalysisRouteImport } from "./../routes/_auth/_deal/deals/$dealId/analysis";
import { Route as AuthProjectSupplierQuoteRequestProjectIdSubProjectIdIndexRouteImport } from "./../routes/_auth/_project/supplier-quote-request.$projectId.$subProjectId/index";
import { Route as AuthProjectPurchasesProjectIdSubProjectIdIndexRouteImport } from "./../routes/_auth/_project/purchases.$projectId.$subProjectId/index";
import { Route as AuthProjectMarginOptimizationProjectIdSubProjectIdIndexRouteImport } from "./../routes/_auth/_project/margin-optimization.$projectId.$subProjectId/index";
import { Route as AuthProjectBidRowDetailsProjectIdSubProjectIdIndexRouteImport } from "./../routes/_auth/_project/bid-row-details.$projectId.$subProjectId/index";
import { Route as AuthDealDealsDealIdDetailsIndexRouteImport } from "./../routes/_auth/_deal/deals/$dealId/details.index";
import { Route as AuthProjectSupplierQuoteRequestProjectIdSubProjectIdReceivedQuotesRouteImport } from "./../routes/_auth/_project/supplier-quote-request.$projectId.$subProjectId/received-quotes";
import { Route as AuthProjectPurchasesProjectIdSubProjectIdSupplierQuoteRouteImport } from "./../routes/_auth/_project/purchases.$projectId.$subProjectId/supplier-quote";
import { Route as AuthProjectMarginOptimizationProjectIdSubProjectIdScenarioRouteImport } from "./../routes/_auth/_project/margin-optimization.$projectId.$subProjectId/scenario";
import { Route as AuthProjectImportProjectIdSubProjectIdLinkRouteImport } from "./../routes/_auth/_project/import_.$projectId.$subProjectId.link";
import { Route as AuthProjectBidRowDetailsProjectIdSubProjectIdWorkPackagesRouteImport } from "./../routes/_auth/_project/bid-row-details.$projectId.$subProjectId/work-packages";
import { Route as AuthProjectBidRowDetailsProjectIdSubProjectIdUnassignedWorkPackagesRouteImport } from "./../routes/_auth/_project/bid-row-details.$projectId.$subProjectId/unassigned-work-packages";
import { Route as AuthDealDealsDealIdImportSubProjectIdRouteImport } from "./../routes/_auth/_deal/deals/$dealId/import.$subProjectId";
import { Route as AuthDealDealsDealIdDetailsSubProjectIdRouteImport } from "./../routes/_auth/_deal/deals/$dealId/details.$subProjectId";
import { Route as AuthDealDealsDealIdClientPricingDocumentImportRouteImport } from "./../routes/_auth/_deal/deals/$dealId/client-pricing-document_.import";
import { Route as AuthProjectSupplierQuoteRequestProjectIdSubProjectIdContentContentIdRouteImport } from "./../routes/_auth/_project/supplier-quote-request.$projectId.$subProjectId/content.$contentId";
import { Route as AuthDealDealsDealIdImportSubProjectIdLinkRouteImport } from "./../routes/_auth/_deal/deals/$dealId/import_.$subProjectId.link";

const OnboardingRoute = OnboardingRouteImport.update({
  id: "/onboarding",
  path: "/onboarding",
  getParentRoute: () => rootRouteImport,
} as any);
const MagicLinkRoute = MagicLinkRouteImport.update({
  id: "/magic-link",
  path: "/magic-link",
  getParentRoute: () => rootRouteImport,
} as any);
const No_authRoute = No_authRouteImport.update({
  id: "/_no_auth",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthRoute = AuthRouteImport.update({
  id: "/_auth",
  getParentRoute: () => rootRouteImport,
} as any);
const No_authSignUpRoute = No_authSignUpRouteImport.update({
  id: "/sign-up",
  path: "/sign-up",
  getParentRoute: () => No_authRoute,
} as any);
const No_authSignInRoute = No_authSignInRouteImport.update({
  id: "/sign-in",
  path: "/sign-in",
  getParentRoute: () => No_authRoute,
} as any);
const No_authResetPasswordRoute = No_authResetPasswordRouteImport.update({
  id: "/reset-password",
  path: "/reset-password",
  getParentRoute: () => No_authRoute,
} as any);
const AuthProjectRoute = AuthProjectRouteImport.update({
  id: "/_project",
  getParentRoute: () => AuthRoute,
} as any);
const AuthOrganisationRoute = AuthOrganisationRouteImport.update({
  id: "/_organisation",
  getParentRoute: () => AuthRoute,
} as any);
const AuthFrameRoute = AuthFrameRouteImport.update({
  id: "/_frame",
  getParentRoute: () => AuthRoute,
} as any);
const AuthDealRoute = AuthDealRouteImport.update({
  id: "/_deal",
  getParentRoute: () => AuthRoute,
} as any);
const AuthFrameIndexRoute = AuthFrameIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthFrameRoute,
} as any);
const No_authSsoErrorSplatRoute = No_authSsoErrorSplatRouteImport.update({
  id: "/sso-error/$",
  path: "/sso-error/$",
  getParentRoute: () => No_authRoute,
} as any);
const AuthOrganisationOrganisationRoute =
  AuthOrganisationOrganisationRouteImport.update({
    id: "/organisation",
    path: "/organisation",
    getParentRoute: () => AuthOrganisationRoute,
  } as any);
const AuthFrameWelcomeRoute = AuthFrameWelcomeRouteImport.update({
  id: "/welcome",
  path: "/welcome",
  getParentRoute: () => AuthFrameRoute,
} as any);
const AuthFrameSuppliersRoute = AuthFrameSuppliersRouteImport.update({
  id: "/suppliers",
  path: "/suppliers",
  getParentRoute: () => AuthFrameRoute,
} as any);
const AuthFrameStorybookRoute = AuthFrameStorybookRouteImport.update({
  id: "/storybook",
  path: "/storybook",
  getParentRoute: () => AuthFrameRoute,
} as any);
const AuthFrameSteeringRoute = AuthFrameSteeringRouteImport.update({
  id: "/steering",
  path: "/steering",
  getParentRoute: () => AuthFrameRoute,
} as any);
const AuthFrameLibraryRoute = AuthFrameLibraryRouteImport.update({
  id: "/library",
  path: "/library",
  getParentRoute: () => AuthFrameRoute,
} as any);
const AuthFrameKaraokeRoute = AuthFrameKaraokeRouteImport.update({
  id: "/karaoke",
  path: "/karaoke",
  getParentRoute: () => AuthFrameRoute,
} as any);
const AuthFrameClientsRoute = AuthFrameClientsRouteImport.update({
  id: "/clients",
  path: "/clients",
  getParentRoute: () => AuthFrameRoute,
} as any);
const AuthFrameAbacusRoute = AuthFrameAbacusRouteImport.update({
  id: "/abacus",
  path: "/abacus",
  getParentRoute: () => AuthFrameRoute,
} as any);
const AuthOrganisationOrganisationIndexRoute =
  AuthOrganisationOrganisationIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthOrganisationOrganisationRoute,
  } as any);
const AuthFrameTendersIndexRoute = AuthFrameTendersIndexRouteImport.update({
  id: "/tenders/",
  path: "/tenders/",
  getParentRoute: () => AuthFrameRoute,
} as any);
const AuthFrameSuppliersIndexRoute = AuthFrameSuppliersIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthFrameSuppliersRoute,
} as any);
const AuthFrameStorybookIndexRoute = AuthFrameStorybookIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthFrameStorybookRoute,
} as any);
const AuthFrameDealsIndexRoute = AuthFrameDealsIndexRouteImport.update({
  id: "/deals/",
  path: "/deals/",
  getParentRoute: () => AuthFrameRoute,
} as any);
const AuthFrameClientsIndexRoute = AuthFrameClientsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthFrameClientsRoute,
} as any);
const AuthFrameChronoDevisIndexRoute =
  AuthFrameChronoDevisIndexRouteImport.update({
    id: "/chrono-devis/",
    path: "/chrono-devis/",
    getParentRoute: () => AuthFrameRoute,
  } as any);
const AuthFrameAdminIndexRoute = AuthFrameAdminIndexRouteImport.update({
  id: "/admin/",
  path: "/admin/",
  getParentRoute: () => AuthFrameRoute,
} as any);
const AuthOrganisationOrganisationResourcesRoute =
  AuthOrganisationOrganisationResourcesRouteImport.update({
    id: "/resources",
    path: "/resources",
    getParentRoute: () => AuthOrganisationOrganisationRoute,
  } as any);
const AuthOrganisationOrganisationQuoteCreationRoute =
  AuthOrganisationOrganisationQuoteCreationRouteImport.update({
    id: "/quote-creation",
    path: "/quote-creation",
    getParentRoute: () => AuthOrganisationOrganisationRoute,
  } as any);
const AuthOrganisationOrganisationMembersRoute =
  AuthOrganisationOrganisationMembersRouteImport.update({
    id: "/members",
    path: "/members",
    getParentRoute: () => AuthOrganisationOrganisationRoute,
  } as any);
const AuthOrganisationOrganisationExportsRoute =
  AuthOrganisationOrganisationExportsRouteImport.update({
    id: "/exports",
    path: "/exports",
    getParentRoute: () => AuthOrganisationOrganisationRoute,
  } as any);
const AuthOrganisationOrganisationCompanyInformationRoute =
  AuthOrganisationOrganisationCompanyInformationRouteImport.update({
    id: "/company-information",
    path: "/company-information",
    getParentRoute: () => AuthOrganisationOrganisationRoute,
  } as any);
const AuthFrameSuppliersContactsRoute =
  AuthFrameSuppliersContactsRouteImport.update({
    id: "/contacts",
    path: "/contacts",
    getParentRoute: () => AuthFrameSuppliersRoute,
  } as any);
const AuthFrameSuppliersSupplierIdRoute =
  AuthFrameSuppliersSupplierIdRouteImport.update({
    id: "/$supplierId",
    path: "/$supplierId",
    getParentRoute: () => AuthFrameSuppliersRoute,
  } as any);
const AuthFrameStorybookContentLayoutRoute =
  AuthFrameStorybookContentLayoutRouteImport.update({
    id: "/content-layout",
    path: "/content-layout",
    getParentRoute: () => AuthFrameStorybookRoute,
  } as any);
const AuthFrameClientsContactsRoute =
  AuthFrameClientsContactsRouteImport.update({
    id: "/contacts",
    path: "/contacts",
    getParentRoute: () => AuthFrameClientsRoute,
  } as any);
const AuthFrameClientsCompanyIdRoute =
  AuthFrameClientsCompanyIdRouteImport.update({
    id: "/$companyId",
    path: "/$companyId",
    getParentRoute: () => AuthFrameClientsRoute,
  } as any);
const AuthFrameChronoDevisInternalTrackingRoute =
  AuthFrameChronoDevisInternalTrackingRouteImport.update({
    id: "/chrono-devis/internal-tracking",
    path: "/chrono-devis/internal-tracking",
    getParentRoute: () => AuthFrameRoute,
  } as any);
const AuthFrameAdminMailTestRoute = AuthFrameAdminMailTestRouteImport.update({
  id: "/admin/mail-test",
  path: "/admin/mail-test",
  getParentRoute: () => AuthFrameRoute,
} as any);
const AuthDealDealsDealIdRoute = AuthDealDealsDealIdRouteImport.update({
  id: "/deals/$dealId",
  path: "/deals/$dealId",
  getParentRoute: () => AuthDealRoute,
} as any);
const AuthProjectBidProjectIdIndexRoute =
  AuthProjectBidProjectIdIndexRouteImport.update({
    id: "/bid/$projectId/",
    path: "/bid/$projectId/",
    getParentRoute: () => AuthProjectRoute,
  } as any);
const AuthOrganisationOrganisationResourcesIndexRoute =
  AuthOrganisationOrganisationResourcesIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthOrganisationOrganisationResourcesRoute,
  } as any);
const AuthOrganisationOrganisationExportsIndexRoute =
  AuthOrganisationOrganisationExportsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthOrganisationOrganisationExportsRoute,
  } as any);
const AuthFrameSuppliersSupplierIdIndexRoute =
  AuthFrameSuppliersSupplierIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthFrameSuppliersSupplierIdRoute,
  } as any);
const AuthFrameClientsCompanyIdIndexRoute =
  AuthFrameClientsCompanyIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthFrameClientsCompanyIdRoute,
  } as any);
const AuthDealDealsDealIdIndexRoute =
  AuthDealDealsDealIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthDealDealsDealIdRoute,
  } as any);
const AuthProjectTasksProjectIdSubProjectIdRoute =
  AuthProjectTasksProjectIdSubProjectIdRouteImport.update({
    id: "/tasks/$projectId/$subProjectId",
    path: "/tasks/$projectId/$subProjectId",
    getParentRoute: () => AuthProjectRoute,
  } as any);
const AuthProjectSupplierQuoteRequestProjectIdSubProjectIdRoute =
  AuthProjectSupplierQuoteRequestProjectIdSubProjectIdRouteImport.update({
    id: "/supplier-quote-request/$projectId/$subProjectId",
    path: "/supplier-quote-request/$projectId/$subProjectId",
    getParentRoute: () => AuthProjectRoute,
  } as any);
const AuthProjectSummaryProjectIdSubProjectIdRoute =
  AuthProjectSummaryProjectIdSubProjectIdRouteImport.update({
    id: "/summary/$projectId/$subProjectId",
    path: "/summary/$projectId/$subProjectId",
    getParentRoute: () => AuthProjectRoute,
  } as any);
const AuthProjectPurchasesProjectIdSubProjectIdRoute =
  AuthProjectPurchasesProjectIdSubProjectIdRouteImport.update({
    id: "/purchases/$projectId/$subProjectId",
    path: "/purchases/$projectId/$subProjectId",
    getParentRoute: () => AuthProjectRoute,
  } as any);
const AuthProjectMarginOptimizationProjectIdSubProjectIdRoute =
  AuthProjectMarginOptimizationProjectIdSubProjectIdRouteImport.update({
    id: "/margin-optimization/$projectId/$subProjectId",
    path: "/margin-optimization/$projectId/$subProjectId",
    getParentRoute: () => AuthProjectRoute,
  } as any);
const AuthProjectIndirectCostsProjectIdSubProjectIdRoute =
  AuthProjectIndirectCostsProjectIdSubProjectIdRouteImport.update({
    id: "/indirect-costs/$projectId/$subProjectId",
    path: "/indirect-costs/$projectId/$subProjectId",
    getParentRoute: () => AuthProjectRoute,
  } as any);
const AuthProjectImportProjectIdSubProjectIdRoute =
  AuthProjectImportProjectIdSubProjectIdRouteImport.update({
    id: "/import/$projectId/$subProjectId",
    path: "/import/$projectId/$subProjectId",
    getParentRoute: () => AuthProjectRoute,
  } as any);
const AuthProjectBidProjectIdSubProjectIdRoute =
  AuthProjectBidProjectIdSubProjectIdRouteImport.update({
    id: "/bid/$projectId/$subProjectId",
    path: "/bid/$projectId/$subProjectId",
    getParentRoute: () => AuthProjectRoute,
  } as any);
const AuthProjectBidRowDetailsProjectIdSubProjectIdRoute =
  AuthProjectBidRowDetailsProjectIdSubProjectIdRouteImport.update({
    id: "/bid-row-details/$projectId/$subProjectId",
    path: "/bid-row-details/$projectId/$subProjectId",
    getParentRoute: () => AuthProjectRoute,
  } as any);
const AuthProjectProjectIdSubProjectIdSdpConfigRoute =
  AuthProjectProjectIdSubProjectIdSdpConfigRouteImport.update({
    id: "/$projectId/$subProjectId/sdp-config",
    path: "/$projectId/$subProjectId/sdp-config",
    getParentRoute: () => AuthProjectRoute,
  } as any);
const AuthProjectProjectIdSubProjectIdSdpRoute =
  AuthProjectProjectIdSubProjectIdSdpRouteImport.update({
    id: "/$projectId/$subProjectId/sdp",
    path: "/$projectId/$subProjectId/sdp",
    getParentRoute: () => AuthProjectRoute,
  } as any);
const AuthProjectProjectIdSubProjectIdExportQuoteRoute =
  AuthProjectProjectIdSubProjectIdExportQuoteRouteImport.update({
    id: "/$projectId/$subProjectId/export-quote",
    path: "/$projectId/$subProjectId/export-quote",
    getParentRoute: () => AuthProjectRoute,
  } as any);
const AuthOrganisationOrganisationResourcesTravelCostsRoute =
  AuthOrganisationOrganisationResourcesTravelCostsRouteImport.update({
    id: "/travel-costs",
    path: "/travel-costs",
    getParentRoute: () => AuthOrganisationOrganisationResourcesRoute,
  } as any);
const AuthOrganisationOrganisationResourcesSupplyFamiliesRoute =
  AuthOrganisationOrganisationResourcesSupplyFamiliesRouteImport.update({
    id: "/supply-families",
    path: "/supply-families",
    getParentRoute: () => AuthOrganisationOrganisationResourcesRoute,
  } as any);
const AuthOrganisationOrganisationResourcesSubcontractingRoute =
  AuthOrganisationOrganisationResourcesSubcontractingRouteImport.update({
    id: "/subcontracting",
    path: "/subcontracting",
    getParentRoute: () => AuthOrganisationOrganisationResourcesRoute,
  } as any);
const AuthOrganisationOrganisationResourcesOtherCostsRoute =
  AuthOrganisationOrganisationResourcesOtherCostsRouteImport.update({
    id: "/other-costs",
    path: "/other-costs",
    getParentRoute: () => AuthOrganisationOrganisationResourcesRoute,
  } as any);
const AuthOrganisationOrganisationResourcesLaborRoute =
  AuthOrganisationOrganisationResourcesLaborRouteImport.update({
    id: "/labor",
    path: "/labor",
    getParentRoute: () => AuthOrganisationOrganisationResourcesRoute,
  } as any);
const AuthOrganisationOrganisationResourcesEquipmentRoute =
  AuthOrganisationOrganisationResourcesEquipmentRouteImport.update({
    id: "/equipment",
    path: "/equipment",
    getParentRoute: () => AuthOrganisationOrganisationResourcesRoute,
  } as any);
const AuthOrganisationOrganisationResourcesAdditionalCostsRoute =
  AuthOrganisationOrganisationResourcesAdditionalCostsRouteImport.update({
    id: "/additional-costs",
    path: "/additional-costs",
    getParentRoute: () => AuthOrganisationOrganisationResourcesRoute,
  } as any);
const AuthOrganisationOrganisationExportsQuoteLayoutRoute =
  AuthOrganisationOrganisationExportsQuoteLayoutRouteImport.update({
    id: "/quote-layout",
    path: "/quote-layout",
    getParentRoute: () => AuthOrganisationOrganisationExportsRoute,
  } as any);
const AuthOrganisationOrganisationExportsPriceBreakdownCoefficientsRoute =
  AuthOrganisationOrganisationExportsPriceBreakdownCoefficientsRouteImport.update(
    {
      id: "/price-breakdown-coefficients",
      path: "/price-breakdown-coefficients",
      getParentRoute: () => AuthOrganisationOrganisationExportsRoute,
    } as any,
  );
const AuthFrameSuppliersSupplierIdPricedDeliverablesRoute =
  AuthFrameSuppliersSupplierIdPricedDeliverablesRouteImport.update({
    id: "/priced-deliverables",
    path: "/priced-deliverables",
    getParentRoute: () => AuthFrameSuppliersSupplierIdRoute,
  } as any);
const AuthFrameSuppliersSupplierIdImportedCatalogRoute =
  AuthFrameSuppliersSupplierIdImportedCatalogRouteImport.update({
    id: "/imported-catalog",
    path: "/imported-catalog",
    getParentRoute: () => AuthFrameSuppliersSupplierIdRoute,
  } as any);
const AuthFrameSuppliersSupplierIdContactsRoute =
  AuthFrameSuppliersSupplierIdContactsRouteImport.update({
    id: "/contacts",
    path: "/contacts",
    getParentRoute: () => AuthFrameSuppliersSupplierIdRoute,
  } as any);
const AuthFrameSuppliersSupplierIdCatalogPricesRoute =
  AuthFrameSuppliersSupplierIdCatalogPricesRouteImport.update({
    id: "/catalog-prices",
    path: "/catalog-prices",
    getParentRoute: () => AuthFrameSuppliersSupplierIdRoute,
  } as any);
const AuthFrameClientsCompanyIdProjectsRoute =
  AuthFrameClientsCompanyIdProjectsRouteImport.update({
    id: "/projects",
    path: "/projects",
    getParentRoute: () => AuthFrameClientsCompanyIdRoute,
  } as any);
const AuthFrameClientsCompanyIdContactsRoute =
  AuthFrameClientsCompanyIdContactsRouteImport.update({
    id: "/contacts",
    path: "/contacts",
    getParentRoute: () => AuthFrameClientsCompanyIdRoute,
  } as any);
const AuthDealDealsDealIdQuotesRoute =
  AuthDealDealsDealIdQuotesRouteImport.update({
    id: "/quotes",
    path: "/quotes",
    getParentRoute: () => AuthDealDealsDealIdRoute,
  } as any);
const AuthDealDealsDealIdContractualInformationRoute =
  AuthDealDealsDealIdContractualInformationRouteImport.update({
    id: "/contractual-information",
    path: "/contractual-information",
    getParentRoute: () => AuthDealDealsDealIdRoute,
  } as any);
const AuthDealDealsDealIdClientPricingDocumentRoute =
  AuthDealDealsDealIdClientPricingDocumentRouteImport.update({
    id: "/client-pricing-document",
    path: "/client-pricing-document",
    getParentRoute: () => AuthDealDealsDealIdRoute,
  } as any);
const AuthDealDealsDealIdAnalysisRoute =
  AuthDealDealsDealIdAnalysisRouteImport.update({
    id: "/analysis",
    path: "/analysis",
    getParentRoute: () => AuthDealDealsDealIdRoute,
  } as any);
const AuthProjectSupplierQuoteRequestProjectIdSubProjectIdIndexRoute =
  AuthProjectSupplierQuoteRequestProjectIdSubProjectIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      AuthProjectSupplierQuoteRequestProjectIdSubProjectIdRoute,
  } as any);
const AuthProjectPurchasesProjectIdSubProjectIdIndexRoute =
  AuthProjectPurchasesProjectIdSubProjectIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthProjectPurchasesProjectIdSubProjectIdRoute,
  } as any);
const AuthProjectMarginOptimizationProjectIdSubProjectIdIndexRoute =
  AuthProjectMarginOptimizationProjectIdSubProjectIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      AuthProjectMarginOptimizationProjectIdSubProjectIdRoute,
  } as any);
const AuthProjectBidRowDetailsProjectIdSubProjectIdIndexRoute =
  AuthProjectBidRowDetailsProjectIdSubProjectIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthProjectBidRowDetailsProjectIdSubProjectIdRoute,
  } as any);
const AuthDealDealsDealIdDetailsIndexRoute =
  AuthDealDealsDealIdDetailsIndexRouteImport.update({
    id: "/details/",
    path: "/details/",
    getParentRoute: () => AuthDealDealsDealIdRoute,
  } as any);
const AuthProjectSupplierQuoteRequestProjectIdSubProjectIdReceivedQuotesRoute =
  AuthProjectSupplierQuoteRequestProjectIdSubProjectIdReceivedQuotesRouteImport.update(
    {
      id: "/received-quotes",
      path: "/received-quotes",
      getParentRoute: () =>
        AuthProjectSupplierQuoteRequestProjectIdSubProjectIdRoute,
    } as any,
  );
const AuthProjectPurchasesProjectIdSubProjectIdSupplierQuoteRoute =
  AuthProjectPurchasesProjectIdSubProjectIdSupplierQuoteRouteImport.update({
    id: "/supplier-quote",
    path: "/supplier-quote",
    getParentRoute: () => AuthProjectPurchasesProjectIdSubProjectIdRoute,
  } as any);
const AuthProjectMarginOptimizationProjectIdSubProjectIdScenarioRoute =
  AuthProjectMarginOptimizationProjectIdSubProjectIdScenarioRouteImport.update({
    id: "/scenario",
    path: "/scenario",
    getParentRoute: () =>
      AuthProjectMarginOptimizationProjectIdSubProjectIdRoute,
  } as any);
const AuthProjectImportProjectIdSubProjectIdLinkRoute =
  AuthProjectImportProjectIdSubProjectIdLinkRouteImport.update({
    id: "/import_/$projectId/$subProjectId/link",
    path: "/import/$projectId/$subProjectId/link",
    getParentRoute: () => AuthProjectRoute,
  } as any);
const AuthProjectBidRowDetailsProjectIdSubProjectIdWorkPackagesRoute =
  AuthProjectBidRowDetailsProjectIdSubProjectIdWorkPackagesRouteImport.update({
    id: "/work-packages",
    path: "/work-packages",
    getParentRoute: () => AuthProjectBidRowDetailsProjectIdSubProjectIdRoute,
  } as any);
const AuthProjectBidRowDetailsProjectIdSubProjectIdUnassignedWorkPackagesRoute =
  AuthProjectBidRowDetailsProjectIdSubProjectIdUnassignedWorkPackagesRouteImport.update(
    {
      id: "/unassigned-work-packages",
      path: "/unassigned-work-packages",
      getParentRoute: () => AuthProjectBidRowDetailsProjectIdSubProjectIdRoute,
    } as any,
  );
const AuthDealDealsDealIdImportSubProjectIdRoute =
  AuthDealDealsDealIdImportSubProjectIdRouteImport.update({
    id: "/import/$subProjectId",
    path: "/import/$subProjectId",
    getParentRoute: () => AuthDealDealsDealIdRoute,
  } as any);
const AuthDealDealsDealIdDetailsSubProjectIdRoute =
  AuthDealDealsDealIdDetailsSubProjectIdRouteImport.update({
    id: "/details/$subProjectId",
    path: "/details/$subProjectId",
    getParentRoute: () => AuthDealDealsDealIdRoute,
  } as any);
const AuthDealDealsDealIdClientPricingDocumentImportRoute =
  AuthDealDealsDealIdClientPricingDocumentImportRouteImport.update({
    id: "/client-pricing-document_/import",
    path: "/client-pricing-document/import",
    getParentRoute: () => AuthDealDealsDealIdRoute,
  } as any);
const AuthProjectSupplierQuoteRequestProjectIdSubProjectIdContentContentIdRoute =
  AuthProjectSupplierQuoteRequestProjectIdSubProjectIdContentContentIdRouteImport.update(
    {
      id: "/content/$contentId",
      path: "/content/$contentId",
      getParentRoute: () =>
        AuthProjectSupplierQuoteRequestProjectIdSubProjectIdRoute,
    } as any,
  );
const AuthDealDealsDealIdImportSubProjectIdLinkRoute =
  AuthDealDealsDealIdImportSubProjectIdLinkRouteImport.update({
    id: "/import_/$subProjectId/link",
    path: "/import/$subProjectId/link",
    getParentRoute: () => AuthDealDealsDealIdRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof AuthFrameIndexRoute;
  "/magic-link": typeof MagicLinkRoute;
  "/onboarding": typeof OnboardingRoute;
  "/reset-password": typeof No_authResetPasswordRoute;
  "/sign-in": typeof No_authSignInRoute;
  "/sign-up": typeof No_authSignUpRoute;
  "/abacus": typeof AuthFrameAbacusRoute;
  "/clients": typeof AuthFrameClientsRouteWithChildren;
  "/karaoke": typeof AuthFrameKaraokeRoute;
  "/library": typeof AuthFrameLibraryRoute;
  "/steering": typeof AuthFrameSteeringRoute;
  "/storybook": typeof AuthFrameStorybookRouteWithChildren;
  "/suppliers": typeof AuthFrameSuppliersRouteWithChildren;
  "/welcome": typeof AuthFrameWelcomeRoute;
  "/organisation": typeof AuthOrganisationOrganisationRouteWithChildren;
  "/sso-error/$": typeof No_authSsoErrorSplatRoute;
  "/deals/$dealId": typeof AuthDealDealsDealIdRouteWithChildren;
  "/admin/mail-test": typeof AuthFrameAdminMailTestRoute;
  "/chrono-devis/internal-tracking": typeof AuthFrameChronoDevisInternalTrackingRoute;
  "/clients/$companyId": typeof AuthFrameClientsCompanyIdRouteWithChildren;
  "/clients/contacts": typeof AuthFrameClientsContactsRoute;
  "/storybook/content-layout": typeof AuthFrameStorybookContentLayoutRoute;
  "/suppliers/$supplierId": typeof AuthFrameSuppliersSupplierIdRouteWithChildren;
  "/suppliers/contacts": typeof AuthFrameSuppliersContactsRoute;
  "/organisation/company-information": typeof AuthOrganisationOrganisationCompanyInformationRoute;
  "/organisation/exports": typeof AuthOrganisationOrganisationExportsRouteWithChildren;
  "/organisation/members": typeof AuthOrganisationOrganisationMembersRoute;
  "/organisation/quote-creation": typeof AuthOrganisationOrganisationQuoteCreationRoute;
  "/organisation/resources": typeof AuthOrganisationOrganisationResourcesRouteWithChildren;
  "/admin/": typeof AuthFrameAdminIndexRoute;
  "/chrono-devis/": typeof AuthFrameChronoDevisIndexRoute;
  "/clients/": typeof AuthFrameClientsIndexRoute;
  "/deals/": typeof AuthFrameDealsIndexRoute;
  "/storybook/": typeof AuthFrameStorybookIndexRoute;
  "/suppliers/": typeof AuthFrameSuppliersIndexRoute;
  "/tenders/": typeof AuthFrameTendersIndexRoute;
  "/organisation/": typeof AuthOrganisationOrganisationIndexRoute;
  "/deals/$dealId/analysis": typeof AuthDealDealsDealIdAnalysisRoute;
  "/deals/$dealId/client-pricing-document": typeof AuthDealDealsDealIdClientPricingDocumentRoute;
  "/deals/$dealId/contractual-information": typeof AuthDealDealsDealIdContractualInformationRoute;
  "/deals/$dealId/quotes": typeof AuthDealDealsDealIdQuotesRoute;
  "/clients/$companyId/contacts": typeof AuthFrameClientsCompanyIdContactsRoute;
  "/clients/$companyId/projects": typeof AuthFrameClientsCompanyIdProjectsRoute;
  "/suppliers/$supplierId/catalog-prices": typeof AuthFrameSuppliersSupplierIdCatalogPricesRoute;
  "/suppliers/$supplierId/contacts": typeof AuthFrameSuppliersSupplierIdContactsRoute;
  "/suppliers/$supplierId/imported-catalog": typeof AuthFrameSuppliersSupplierIdImportedCatalogRoute;
  "/suppliers/$supplierId/priced-deliverables": typeof AuthFrameSuppliersSupplierIdPricedDeliverablesRoute;
  "/organisation/exports/price-breakdown-coefficients": typeof AuthOrganisationOrganisationExportsPriceBreakdownCoefficientsRoute;
  "/organisation/exports/quote-layout": typeof AuthOrganisationOrganisationExportsQuoteLayoutRoute;
  "/organisation/resources/additional-costs": typeof AuthOrganisationOrganisationResourcesAdditionalCostsRoute;
  "/organisation/resources/equipment": typeof AuthOrganisationOrganisationResourcesEquipmentRoute;
  "/organisation/resources/labor": typeof AuthOrganisationOrganisationResourcesLaborRoute;
  "/organisation/resources/other-costs": typeof AuthOrganisationOrganisationResourcesOtherCostsRoute;
  "/organisation/resources/subcontracting": typeof AuthOrganisationOrganisationResourcesSubcontractingRoute;
  "/organisation/resources/supply-families": typeof AuthOrganisationOrganisationResourcesSupplyFamiliesRoute;
  "/organisation/resources/travel-costs": typeof AuthOrganisationOrganisationResourcesTravelCostsRoute;
  "/$projectId/$subProjectId/export-quote": typeof AuthProjectProjectIdSubProjectIdExportQuoteRoute;
  "/$projectId/$subProjectId/sdp": typeof AuthProjectProjectIdSubProjectIdSdpRoute;
  "/$projectId/$subProjectId/sdp-config": typeof AuthProjectProjectIdSubProjectIdSdpConfigRoute;
  "/bid-row-details/$projectId/$subProjectId": typeof AuthProjectBidRowDetailsProjectIdSubProjectIdRouteWithChildren;
  "/bid/$projectId/$subProjectId": typeof AuthProjectBidProjectIdSubProjectIdRoute;
  "/import/$projectId/$subProjectId": typeof AuthProjectImportProjectIdSubProjectIdRoute;
  "/indirect-costs/$projectId/$subProjectId": typeof AuthProjectIndirectCostsProjectIdSubProjectIdRoute;
  "/margin-optimization/$projectId/$subProjectId": typeof AuthProjectMarginOptimizationProjectIdSubProjectIdRouteWithChildren;
  "/purchases/$projectId/$subProjectId": typeof AuthProjectPurchasesProjectIdSubProjectIdRouteWithChildren;
  "/summary/$projectId/$subProjectId": typeof AuthProjectSummaryProjectIdSubProjectIdRoute;
  "/supplier-quote-request/$projectId/$subProjectId": typeof AuthProjectSupplierQuoteRequestProjectIdSubProjectIdRouteWithChildren;
  "/tasks/$projectId/$subProjectId": typeof AuthProjectTasksProjectIdSubProjectIdRoute;
  "/deals/$dealId/": typeof AuthDealDealsDealIdIndexRoute;
  "/clients/$companyId/": typeof AuthFrameClientsCompanyIdIndexRoute;
  "/suppliers/$supplierId/": typeof AuthFrameSuppliersSupplierIdIndexRoute;
  "/organisation/exports/": typeof AuthOrganisationOrganisationExportsIndexRoute;
  "/organisation/resources/": typeof AuthOrganisationOrganisationResourcesIndexRoute;
  "/bid/$projectId/": typeof AuthProjectBidProjectIdIndexRoute;
  "/deals/$dealId/client-pricing-document/import": typeof AuthDealDealsDealIdClientPricingDocumentImportRoute;
  "/deals/$dealId/details/$subProjectId": typeof AuthDealDealsDealIdDetailsSubProjectIdRoute;
  "/deals/$dealId/import/$subProjectId": typeof AuthDealDealsDealIdImportSubProjectIdRoute;
  "/bid-row-details/$projectId/$subProjectId/unassigned-work-packages": typeof AuthProjectBidRowDetailsProjectIdSubProjectIdUnassignedWorkPackagesRoute;
  "/bid-row-details/$projectId/$subProjectId/work-packages": typeof AuthProjectBidRowDetailsProjectIdSubProjectIdWorkPackagesRoute;
  "/import/$projectId/$subProjectId/link": typeof AuthProjectImportProjectIdSubProjectIdLinkRoute;
  "/margin-optimization/$projectId/$subProjectId/scenario": typeof AuthProjectMarginOptimizationProjectIdSubProjectIdScenarioRoute;
  "/purchases/$projectId/$subProjectId/supplier-quote": typeof AuthProjectPurchasesProjectIdSubProjectIdSupplierQuoteRoute;
  "/supplier-quote-request/$projectId/$subProjectId/received-quotes": typeof AuthProjectSupplierQuoteRequestProjectIdSubProjectIdReceivedQuotesRoute;
  "/deals/$dealId/details/": typeof AuthDealDealsDealIdDetailsIndexRoute;
  "/bid-row-details/$projectId/$subProjectId/": typeof AuthProjectBidRowDetailsProjectIdSubProjectIdIndexRoute;
  "/margin-optimization/$projectId/$subProjectId/": typeof AuthProjectMarginOptimizationProjectIdSubProjectIdIndexRoute;
  "/purchases/$projectId/$subProjectId/": typeof AuthProjectPurchasesProjectIdSubProjectIdIndexRoute;
  "/supplier-quote-request/$projectId/$subProjectId/": typeof AuthProjectSupplierQuoteRequestProjectIdSubProjectIdIndexRoute;
  "/deals/$dealId/import/$subProjectId/link": typeof AuthDealDealsDealIdImportSubProjectIdLinkRoute;
  "/supplier-quote-request/$projectId/$subProjectId/content/$contentId": typeof AuthProjectSupplierQuoteRequestProjectIdSubProjectIdContentContentIdRoute;
}
export interface FileRoutesByTo {
  "/": typeof AuthFrameIndexRoute;
  "/magic-link": typeof MagicLinkRoute;
  "/onboarding": typeof OnboardingRoute;
  "/reset-password": typeof No_authResetPasswordRoute;
  "/sign-in": typeof No_authSignInRoute;
  "/sign-up": typeof No_authSignUpRoute;
  "/abacus": typeof AuthFrameAbacusRoute;
  "/karaoke": typeof AuthFrameKaraokeRoute;
  "/library": typeof AuthFrameLibraryRoute;
  "/steering": typeof AuthFrameSteeringRoute;
  "/welcome": typeof AuthFrameWelcomeRoute;
  "/sso-error/$": typeof No_authSsoErrorSplatRoute;
  "/admin/mail-test": typeof AuthFrameAdminMailTestRoute;
  "/chrono-devis/internal-tracking": typeof AuthFrameChronoDevisInternalTrackingRoute;
  "/clients/contacts": typeof AuthFrameClientsContactsRoute;
  "/storybook/content-layout": typeof AuthFrameStorybookContentLayoutRoute;
  "/suppliers/contacts": typeof AuthFrameSuppliersContactsRoute;
  "/organisation/company-information": typeof AuthOrganisationOrganisationCompanyInformationRoute;
  "/organisation/members": typeof AuthOrganisationOrganisationMembersRoute;
  "/organisation/quote-creation": typeof AuthOrganisationOrganisationQuoteCreationRoute;
  "/admin": typeof AuthFrameAdminIndexRoute;
  "/chrono-devis": typeof AuthFrameChronoDevisIndexRoute;
  "/clients": typeof AuthFrameClientsIndexRoute;
  "/deals": typeof AuthFrameDealsIndexRoute;
  "/storybook": typeof AuthFrameStorybookIndexRoute;
  "/suppliers": typeof AuthFrameSuppliersIndexRoute;
  "/tenders": typeof AuthFrameTendersIndexRoute;
  "/organisation": typeof AuthOrganisationOrganisationIndexRoute;
  "/deals/$dealId/analysis": typeof AuthDealDealsDealIdAnalysisRoute;
  "/deals/$dealId/client-pricing-document": typeof AuthDealDealsDealIdClientPricingDocumentRoute;
  "/deals/$dealId/contractual-information": typeof AuthDealDealsDealIdContractualInformationRoute;
  "/deals/$dealId/quotes": typeof AuthDealDealsDealIdQuotesRoute;
  "/clients/$companyId/contacts": typeof AuthFrameClientsCompanyIdContactsRoute;
  "/clients/$companyId/projects": typeof AuthFrameClientsCompanyIdProjectsRoute;
  "/suppliers/$supplierId/catalog-prices": typeof AuthFrameSuppliersSupplierIdCatalogPricesRoute;
  "/suppliers/$supplierId/contacts": typeof AuthFrameSuppliersSupplierIdContactsRoute;
  "/suppliers/$supplierId/imported-catalog": typeof AuthFrameSuppliersSupplierIdImportedCatalogRoute;
  "/suppliers/$supplierId/priced-deliverables": typeof AuthFrameSuppliersSupplierIdPricedDeliverablesRoute;
  "/organisation/exports/price-breakdown-coefficients": typeof AuthOrganisationOrganisationExportsPriceBreakdownCoefficientsRoute;
  "/organisation/exports/quote-layout": typeof AuthOrganisationOrganisationExportsQuoteLayoutRoute;
  "/organisation/resources/additional-costs": typeof AuthOrganisationOrganisationResourcesAdditionalCostsRoute;
  "/organisation/resources/equipment": typeof AuthOrganisationOrganisationResourcesEquipmentRoute;
  "/organisation/resources/labor": typeof AuthOrganisationOrganisationResourcesLaborRoute;
  "/organisation/resources/other-costs": typeof AuthOrganisationOrganisationResourcesOtherCostsRoute;
  "/organisation/resources/subcontracting": typeof AuthOrganisationOrganisationResourcesSubcontractingRoute;
  "/organisation/resources/supply-families": typeof AuthOrganisationOrganisationResourcesSupplyFamiliesRoute;
  "/organisation/resources/travel-costs": typeof AuthOrganisationOrganisationResourcesTravelCostsRoute;
  "/$projectId/$subProjectId/export-quote": typeof AuthProjectProjectIdSubProjectIdExportQuoteRoute;
  "/$projectId/$subProjectId/sdp": typeof AuthProjectProjectIdSubProjectIdSdpRoute;
  "/$projectId/$subProjectId/sdp-config": typeof AuthProjectProjectIdSubProjectIdSdpConfigRoute;
  "/bid/$projectId/$subProjectId": typeof AuthProjectBidProjectIdSubProjectIdRoute;
  "/import/$projectId/$subProjectId": typeof AuthProjectImportProjectIdSubProjectIdRoute;
  "/indirect-costs/$projectId/$subProjectId": typeof AuthProjectIndirectCostsProjectIdSubProjectIdRoute;
  "/summary/$projectId/$subProjectId": typeof AuthProjectSummaryProjectIdSubProjectIdRoute;
  "/tasks/$projectId/$subProjectId": typeof AuthProjectTasksProjectIdSubProjectIdRoute;
  "/deals/$dealId": typeof AuthDealDealsDealIdIndexRoute;
  "/clients/$companyId": typeof AuthFrameClientsCompanyIdIndexRoute;
  "/suppliers/$supplierId": typeof AuthFrameSuppliersSupplierIdIndexRoute;
  "/organisation/exports": typeof AuthOrganisationOrganisationExportsIndexRoute;
  "/organisation/resources": typeof AuthOrganisationOrganisationResourcesIndexRoute;
  "/bid/$projectId": typeof AuthProjectBidProjectIdIndexRoute;
  "/deals/$dealId/client-pricing-document/import": typeof AuthDealDealsDealIdClientPricingDocumentImportRoute;
  "/deals/$dealId/details/$subProjectId": typeof AuthDealDealsDealIdDetailsSubProjectIdRoute;
  "/deals/$dealId/import/$subProjectId": typeof AuthDealDealsDealIdImportSubProjectIdRoute;
  "/bid-row-details/$projectId/$subProjectId/unassigned-work-packages": typeof AuthProjectBidRowDetailsProjectIdSubProjectIdUnassignedWorkPackagesRoute;
  "/bid-row-details/$projectId/$subProjectId/work-packages": typeof AuthProjectBidRowDetailsProjectIdSubProjectIdWorkPackagesRoute;
  "/import/$projectId/$subProjectId/link": typeof AuthProjectImportProjectIdSubProjectIdLinkRoute;
  "/margin-optimization/$projectId/$subProjectId/scenario": typeof AuthProjectMarginOptimizationProjectIdSubProjectIdScenarioRoute;
  "/purchases/$projectId/$subProjectId/supplier-quote": typeof AuthProjectPurchasesProjectIdSubProjectIdSupplierQuoteRoute;
  "/supplier-quote-request/$projectId/$subProjectId/received-quotes": typeof AuthProjectSupplierQuoteRequestProjectIdSubProjectIdReceivedQuotesRoute;
  "/deals/$dealId/details": typeof AuthDealDealsDealIdDetailsIndexRoute;
  "/bid-row-details/$projectId/$subProjectId": typeof AuthProjectBidRowDetailsProjectIdSubProjectIdIndexRoute;
  "/margin-optimization/$projectId/$subProjectId": typeof AuthProjectMarginOptimizationProjectIdSubProjectIdIndexRoute;
  "/purchases/$projectId/$subProjectId": typeof AuthProjectPurchasesProjectIdSubProjectIdIndexRoute;
  "/supplier-quote-request/$projectId/$subProjectId": typeof AuthProjectSupplierQuoteRequestProjectIdSubProjectIdIndexRoute;
  "/deals/$dealId/import/$subProjectId/link": typeof AuthDealDealsDealIdImportSubProjectIdLinkRoute;
  "/supplier-quote-request/$projectId/$subProjectId/content/$contentId": typeof AuthProjectSupplierQuoteRequestProjectIdSubProjectIdContentContentIdRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/_auth": typeof AuthRouteWithChildren;
  "/_no_auth": typeof No_authRouteWithChildren;
  "/magic-link": typeof MagicLinkRoute;
  "/onboarding": typeof OnboardingRoute;
  "/_auth/_deal": typeof AuthDealRouteWithChildren;
  "/_auth/_frame": typeof AuthFrameRouteWithChildren;
  "/_auth/_organisation": typeof AuthOrganisationRouteWithChildren;
  "/_auth/_project": typeof AuthProjectRouteWithChildren;
  "/_no_auth/reset-password": typeof No_authResetPasswordRoute;
  "/_no_auth/sign-in": typeof No_authSignInRoute;
  "/_no_auth/sign-up": typeof No_authSignUpRoute;
  "/_auth/_frame/abacus": typeof AuthFrameAbacusRoute;
  "/_auth/_frame/clients": typeof AuthFrameClientsRouteWithChildren;
  "/_auth/_frame/karaoke": typeof AuthFrameKaraokeRoute;
  "/_auth/_frame/library": typeof AuthFrameLibraryRoute;
  "/_auth/_frame/steering": typeof AuthFrameSteeringRoute;
  "/_auth/_frame/storybook": typeof AuthFrameStorybookRouteWithChildren;
  "/_auth/_frame/suppliers": typeof AuthFrameSuppliersRouteWithChildren;
  "/_auth/_frame/welcome": typeof AuthFrameWelcomeRoute;
  "/_auth/_organisation/organisation": typeof AuthOrganisationOrganisationRouteWithChildren;
  "/_no_auth/sso-error/$": typeof No_authSsoErrorSplatRoute;
  "/_auth/_frame/": typeof AuthFrameIndexRoute;
  "/_auth/_deal/deals/$dealId": typeof AuthDealDealsDealIdRouteWithChildren;
  "/_auth/_frame/admin/mail-test": typeof AuthFrameAdminMailTestRoute;
  "/_auth/_frame/chrono-devis/internal-tracking": typeof AuthFrameChronoDevisInternalTrackingRoute;
  "/_auth/_frame/clients/$companyId": typeof AuthFrameClientsCompanyIdRouteWithChildren;
  "/_auth/_frame/clients/contacts": typeof AuthFrameClientsContactsRoute;
  "/_auth/_frame/storybook/content-layout": typeof AuthFrameStorybookContentLayoutRoute;
  "/_auth/_frame/suppliers/$supplierId": typeof AuthFrameSuppliersSupplierIdRouteWithChildren;
  "/_auth/_frame/suppliers/contacts": typeof AuthFrameSuppliersContactsRoute;
  "/_auth/_organisation/organisation/company-information": typeof AuthOrganisationOrganisationCompanyInformationRoute;
  "/_auth/_organisation/organisation/exports": typeof AuthOrganisationOrganisationExportsRouteWithChildren;
  "/_auth/_organisation/organisation/members": typeof AuthOrganisationOrganisationMembersRoute;
  "/_auth/_organisation/organisation/quote-creation": typeof AuthOrganisationOrganisationQuoteCreationRoute;
  "/_auth/_organisation/organisation/resources": typeof AuthOrganisationOrganisationResourcesRouteWithChildren;
  "/_auth/_frame/admin/": typeof AuthFrameAdminIndexRoute;
  "/_auth/_frame/chrono-devis/": typeof AuthFrameChronoDevisIndexRoute;
  "/_auth/_frame/clients/": typeof AuthFrameClientsIndexRoute;
  "/_auth/_frame/deals/": typeof AuthFrameDealsIndexRoute;
  "/_auth/_frame/storybook/": typeof AuthFrameStorybookIndexRoute;
  "/_auth/_frame/suppliers/": typeof AuthFrameSuppliersIndexRoute;
  "/_auth/_frame/tenders/": typeof AuthFrameTendersIndexRoute;
  "/_auth/_organisation/organisation/": typeof AuthOrganisationOrganisationIndexRoute;
  "/_auth/_deal/deals/$dealId/analysis": typeof AuthDealDealsDealIdAnalysisRoute;
  "/_auth/_deal/deals/$dealId/client-pricing-document": typeof AuthDealDealsDealIdClientPricingDocumentRoute;
  "/_auth/_deal/deals/$dealId/contractual-information": typeof AuthDealDealsDealIdContractualInformationRoute;
  "/_auth/_deal/deals/$dealId/quotes": typeof AuthDealDealsDealIdQuotesRoute;
  "/_auth/_frame/clients/$companyId/contacts": typeof AuthFrameClientsCompanyIdContactsRoute;
  "/_auth/_frame/clients/$companyId/projects": typeof AuthFrameClientsCompanyIdProjectsRoute;
  "/_auth/_frame/suppliers/$supplierId/catalog-prices": typeof AuthFrameSuppliersSupplierIdCatalogPricesRoute;
  "/_auth/_frame/suppliers/$supplierId/contacts": typeof AuthFrameSuppliersSupplierIdContactsRoute;
  "/_auth/_frame/suppliers/$supplierId/imported-catalog": typeof AuthFrameSuppliersSupplierIdImportedCatalogRoute;
  "/_auth/_frame/suppliers/$supplierId/priced-deliverables": typeof AuthFrameSuppliersSupplierIdPricedDeliverablesRoute;
  "/_auth/_organisation/organisation/exports/price-breakdown-coefficients": typeof AuthOrganisationOrganisationExportsPriceBreakdownCoefficientsRoute;
  "/_auth/_organisation/organisation/exports/quote-layout": typeof AuthOrganisationOrganisationExportsQuoteLayoutRoute;
  "/_auth/_organisation/organisation/resources/additional-costs": typeof AuthOrganisationOrganisationResourcesAdditionalCostsRoute;
  "/_auth/_organisation/organisation/resources/equipment": typeof AuthOrganisationOrganisationResourcesEquipmentRoute;
  "/_auth/_organisation/organisation/resources/labor": typeof AuthOrganisationOrganisationResourcesLaborRoute;
  "/_auth/_organisation/organisation/resources/other-costs": typeof AuthOrganisationOrganisationResourcesOtherCostsRoute;
  "/_auth/_organisation/organisation/resources/subcontracting": typeof AuthOrganisationOrganisationResourcesSubcontractingRoute;
  "/_auth/_organisation/organisation/resources/supply-families": typeof AuthOrganisationOrganisationResourcesSupplyFamiliesRoute;
  "/_auth/_organisation/organisation/resources/travel-costs": typeof AuthOrganisationOrganisationResourcesTravelCostsRoute;
  "/_auth/_project/$projectId/$subProjectId/export-quote": typeof AuthProjectProjectIdSubProjectIdExportQuoteRoute;
  "/_auth/_project/$projectId/$subProjectId/sdp": typeof AuthProjectProjectIdSubProjectIdSdpRoute;
  "/_auth/_project/$projectId/$subProjectId/sdp-config": typeof AuthProjectProjectIdSubProjectIdSdpConfigRoute;
  "/_auth/_project/bid-row-details/$projectId/$subProjectId": typeof AuthProjectBidRowDetailsProjectIdSubProjectIdRouteWithChildren;
  "/_auth/_project/bid/$projectId/$subProjectId": typeof AuthProjectBidProjectIdSubProjectIdRoute;
  "/_auth/_project/import/$projectId/$subProjectId": typeof AuthProjectImportProjectIdSubProjectIdRoute;
  "/_auth/_project/indirect-costs/$projectId/$subProjectId": typeof AuthProjectIndirectCostsProjectIdSubProjectIdRoute;
  "/_auth/_project/margin-optimization/$projectId/$subProjectId": typeof AuthProjectMarginOptimizationProjectIdSubProjectIdRouteWithChildren;
  "/_auth/_project/purchases/$projectId/$subProjectId": typeof AuthProjectPurchasesProjectIdSubProjectIdRouteWithChildren;
  "/_auth/_project/summary/$projectId/$subProjectId": typeof AuthProjectSummaryProjectIdSubProjectIdRoute;
  "/_auth/_project/supplier-quote-request/$projectId/$subProjectId": typeof AuthProjectSupplierQuoteRequestProjectIdSubProjectIdRouteWithChildren;
  "/_auth/_project/tasks/$projectId/$subProjectId": typeof AuthProjectTasksProjectIdSubProjectIdRoute;
  "/_auth/_deal/deals/$dealId/": typeof AuthDealDealsDealIdIndexRoute;
  "/_auth/_frame/clients/$companyId/": typeof AuthFrameClientsCompanyIdIndexRoute;
  "/_auth/_frame/suppliers/$supplierId/": typeof AuthFrameSuppliersSupplierIdIndexRoute;
  "/_auth/_organisation/organisation/exports/": typeof AuthOrganisationOrganisationExportsIndexRoute;
  "/_auth/_organisation/organisation/resources/": typeof AuthOrganisationOrganisationResourcesIndexRoute;
  "/_auth/_project/bid/$projectId/": typeof AuthProjectBidProjectIdIndexRoute;
  "/_auth/_deal/deals/$dealId/client-pricing-document_/import": typeof AuthDealDealsDealIdClientPricingDocumentImportRoute;
  "/_auth/_deal/deals/$dealId/details/$subProjectId": typeof AuthDealDealsDealIdDetailsSubProjectIdRoute;
  "/_auth/_deal/deals/$dealId/import/$subProjectId": typeof AuthDealDealsDealIdImportSubProjectIdRoute;
  "/_auth/_project/bid-row-details/$projectId/$subProjectId/unassigned-work-packages": typeof AuthProjectBidRowDetailsProjectIdSubProjectIdUnassignedWorkPackagesRoute;
  "/_auth/_project/bid-row-details/$projectId/$subProjectId/work-packages": typeof AuthProjectBidRowDetailsProjectIdSubProjectIdWorkPackagesRoute;
  "/_auth/_project/import_/$projectId/$subProjectId/link": typeof AuthProjectImportProjectIdSubProjectIdLinkRoute;
  "/_auth/_project/margin-optimization/$projectId/$subProjectId/scenario": typeof AuthProjectMarginOptimizationProjectIdSubProjectIdScenarioRoute;
  "/_auth/_project/purchases/$projectId/$subProjectId/supplier-quote": typeof AuthProjectPurchasesProjectIdSubProjectIdSupplierQuoteRoute;
  "/_auth/_project/supplier-quote-request/$projectId/$subProjectId/received-quotes": typeof AuthProjectSupplierQuoteRequestProjectIdSubProjectIdReceivedQuotesRoute;
  "/_auth/_deal/deals/$dealId/details/": typeof AuthDealDealsDealIdDetailsIndexRoute;
  "/_auth/_project/bid-row-details/$projectId/$subProjectId/": typeof AuthProjectBidRowDetailsProjectIdSubProjectIdIndexRoute;
  "/_auth/_project/margin-optimization/$projectId/$subProjectId/": typeof AuthProjectMarginOptimizationProjectIdSubProjectIdIndexRoute;
  "/_auth/_project/purchases/$projectId/$subProjectId/": typeof AuthProjectPurchasesProjectIdSubProjectIdIndexRoute;
  "/_auth/_project/supplier-quote-request/$projectId/$subProjectId/": typeof AuthProjectSupplierQuoteRequestProjectIdSubProjectIdIndexRoute;
  "/_auth/_deal/deals/$dealId/import_/$subProjectId/link": typeof AuthDealDealsDealIdImportSubProjectIdLinkRoute;
  "/_auth/_project/supplier-quote-request/$projectId/$subProjectId/content/$contentId": typeof AuthProjectSupplierQuoteRequestProjectIdSubProjectIdContentContentIdRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/magic-link"
    | "/onboarding"
    | "/reset-password"
    | "/sign-in"
    | "/sign-up"
    | "/abacus"
    | "/clients"
    | "/karaoke"
    | "/library"
    | "/steering"
    | "/storybook"
    | "/suppliers"
    | "/welcome"
    | "/organisation"
    | "/sso-error/$"
    | "/deals/$dealId"
    | "/admin/mail-test"
    | "/chrono-devis/internal-tracking"
    | "/clients/$companyId"
    | "/clients/contacts"
    | "/storybook/content-layout"
    | "/suppliers/$supplierId"
    | "/suppliers/contacts"
    | "/organisation/company-information"
    | "/organisation/exports"
    | "/organisation/members"
    | "/organisation/quote-creation"
    | "/organisation/resources"
    | "/admin/"
    | "/chrono-devis/"
    | "/clients/"
    | "/deals/"
    | "/storybook/"
    | "/suppliers/"
    | "/tenders/"
    | "/organisation/"
    | "/deals/$dealId/analysis"
    | "/deals/$dealId/client-pricing-document"
    | "/deals/$dealId/contractual-information"
    | "/deals/$dealId/quotes"
    | "/clients/$companyId/contacts"
    | "/clients/$companyId/projects"
    | "/suppliers/$supplierId/catalog-prices"
    | "/suppliers/$supplierId/contacts"
    | "/suppliers/$supplierId/imported-catalog"
    | "/suppliers/$supplierId/priced-deliverables"
    | "/organisation/exports/price-breakdown-coefficients"
    | "/organisation/exports/quote-layout"
    | "/organisation/resources/additional-costs"
    | "/organisation/resources/equipment"
    | "/organisation/resources/labor"
    | "/organisation/resources/other-costs"
    | "/organisation/resources/subcontracting"
    | "/organisation/resources/supply-families"
    | "/organisation/resources/travel-costs"
    | "/$projectId/$subProjectId/export-quote"
    | "/$projectId/$subProjectId/sdp"
    | "/$projectId/$subProjectId/sdp-config"
    | "/bid-row-details/$projectId/$subProjectId"
    | "/bid/$projectId/$subProjectId"
    | "/import/$projectId/$subProjectId"
    | "/indirect-costs/$projectId/$subProjectId"
    | "/margin-optimization/$projectId/$subProjectId"
    | "/purchases/$projectId/$subProjectId"
    | "/summary/$projectId/$subProjectId"
    | "/supplier-quote-request/$projectId/$subProjectId"
    | "/tasks/$projectId/$subProjectId"
    | "/deals/$dealId/"
    | "/clients/$companyId/"
    | "/suppliers/$supplierId/"
    | "/organisation/exports/"
    | "/organisation/resources/"
    | "/bid/$projectId/"
    | "/deals/$dealId/client-pricing-document/import"
    | "/deals/$dealId/details/$subProjectId"
    | "/deals/$dealId/import/$subProjectId"
    | "/bid-row-details/$projectId/$subProjectId/unassigned-work-packages"
    | "/bid-row-details/$projectId/$subProjectId/work-packages"
    | "/import/$projectId/$subProjectId/link"
    | "/margin-optimization/$projectId/$subProjectId/scenario"
    | "/purchases/$projectId/$subProjectId/supplier-quote"
    | "/supplier-quote-request/$projectId/$subProjectId/received-quotes"
    | "/deals/$dealId/details/"
    | "/bid-row-details/$projectId/$subProjectId/"
    | "/margin-optimization/$projectId/$subProjectId/"
    | "/purchases/$projectId/$subProjectId/"
    | "/supplier-quote-request/$projectId/$subProjectId/"
    | "/deals/$dealId/import/$subProjectId/link"
    | "/supplier-quote-request/$projectId/$subProjectId/content/$contentId";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/magic-link"
    | "/onboarding"
    | "/reset-password"
    | "/sign-in"
    | "/sign-up"
    | "/abacus"
    | "/karaoke"
    | "/library"
    | "/steering"
    | "/welcome"
    | "/sso-error/$"
    | "/admin/mail-test"
    | "/chrono-devis/internal-tracking"
    | "/clients/contacts"
    | "/storybook/content-layout"
    | "/suppliers/contacts"
    | "/organisation/company-information"
    | "/organisation/members"
    | "/organisation/quote-creation"
    | "/admin"
    | "/chrono-devis"
    | "/clients"
    | "/deals"
    | "/storybook"
    | "/suppliers"
    | "/tenders"
    | "/organisation"
    | "/deals/$dealId/analysis"
    | "/deals/$dealId/client-pricing-document"
    | "/deals/$dealId/contractual-information"
    | "/deals/$dealId/quotes"
    | "/clients/$companyId/contacts"
    | "/clients/$companyId/projects"
    | "/suppliers/$supplierId/catalog-prices"
    | "/suppliers/$supplierId/contacts"
    | "/suppliers/$supplierId/imported-catalog"
    | "/suppliers/$supplierId/priced-deliverables"
    | "/organisation/exports/price-breakdown-coefficients"
    | "/organisation/exports/quote-layout"
    | "/organisation/resources/additional-costs"
    | "/organisation/resources/equipment"
    | "/organisation/resources/labor"
    | "/organisation/resources/other-costs"
    | "/organisation/resources/subcontracting"
    | "/organisation/resources/supply-families"
    | "/organisation/resources/travel-costs"
    | "/$projectId/$subProjectId/export-quote"
    | "/$projectId/$subProjectId/sdp"
    | "/$projectId/$subProjectId/sdp-config"
    | "/bid/$projectId/$subProjectId"
    | "/import/$projectId/$subProjectId"
    | "/indirect-costs/$projectId/$subProjectId"
    | "/summary/$projectId/$subProjectId"
    | "/tasks/$projectId/$subProjectId"
    | "/deals/$dealId"
    | "/clients/$companyId"
    | "/suppliers/$supplierId"
    | "/organisation/exports"
    | "/organisation/resources"
    | "/bid/$projectId"
    | "/deals/$dealId/client-pricing-document/import"
    | "/deals/$dealId/details/$subProjectId"
    | "/deals/$dealId/import/$subProjectId"
    | "/bid-row-details/$projectId/$subProjectId/unassigned-work-packages"
    | "/bid-row-details/$projectId/$subProjectId/work-packages"
    | "/import/$projectId/$subProjectId/link"
    | "/margin-optimization/$projectId/$subProjectId/scenario"
    | "/purchases/$projectId/$subProjectId/supplier-quote"
    | "/supplier-quote-request/$projectId/$subProjectId/received-quotes"
    | "/deals/$dealId/details"
    | "/bid-row-details/$projectId/$subProjectId"
    | "/margin-optimization/$projectId/$subProjectId"
    | "/purchases/$projectId/$subProjectId"
    | "/supplier-quote-request/$projectId/$subProjectId"
    | "/deals/$dealId/import/$subProjectId/link"
    | "/supplier-quote-request/$projectId/$subProjectId/content/$contentId";
  id:
    | "__root__"
    | "/_auth"
    | "/_no_auth"
    | "/magic-link"
    | "/onboarding"
    | "/_auth/_deal"
    | "/_auth/_frame"
    | "/_auth/_organisation"
    | "/_auth/_project"
    | "/_no_auth/reset-password"
    | "/_no_auth/sign-in"
    | "/_no_auth/sign-up"
    | "/_auth/_frame/abacus"
    | "/_auth/_frame/clients"
    | "/_auth/_frame/karaoke"
    | "/_auth/_frame/library"
    | "/_auth/_frame/steering"
    | "/_auth/_frame/storybook"
    | "/_auth/_frame/suppliers"
    | "/_auth/_frame/welcome"
    | "/_auth/_organisation/organisation"
    | "/_no_auth/sso-error/$"
    | "/_auth/_frame/"
    | "/_auth/_deal/deals/$dealId"
    | "/_auth/_frame/admin/mail-test"
    | "/_auth/_frame/chrono-devis/internal-tracking"
    | "/_auth/_frame/clients/$companyId"
    | "/_auth/_frame/clients/contacts"
    | "/_auth/_frame/storybook/content-layout"
    | "/_auth/_frame/suppliers/$supplierId"
    | "/_auth/_frame/suppliers/contacts"
    | "/_auth/_organisation/organisation/company-information"
    | "/_auth/_organisation/organisation/exports"
    | "/_auth/_organisation/organisation/members"
    | "/_auth/_organisation/organisation/quote-creation"
    | "/_auth/_organisation/organisation/resources"
    | "/_auth/_frame/admin/"
    | "/_auth/_frame/chrono-devis/"
    | "/_auth/_frame/clients/"
    | "/_auth/_frame/deals/"
    | "/_auth/_frame/storybook/"
    | "/_auth/_frame/suppliers/"
    | "/_auth/_frame/tenders/"
    | "/_auth/_organisation/organisation/"
    | "/_auth/_deal/deals/$dealId/analysis"
    | "/_auth/_deal/deals/$dealId/client-pricing-document"
    | "/_auth/_deal/deals/$dealId/contractual-information"
    | "/_auth/_deal/deals/$dealId/quotes"
    | "/_auth/_frame/clients/$companyId/contacts"
    | "/_auth/_frame/clients/$companyId/projects"
    | "/_auth/_frame/suppliers/$supplierId/catalog-prices"
    | "/_auth/_frame/suppliers/$supplierId/contacts"
    | "/_auth/_frame/suppliers/$supplierId/imported-catalog"
    | "/_auth/_frame/suppliers/$supplierId/priced-deliverables"
    | "/_auth/_organisation/organisation/exports/price-breakdown-coefficients"
    | "/_auth/_organisation/organisation/exports/quote-layout"
    | "/_auth/_organisation/organisation/resources/additional-costs"
    | "/_auth/_organisation/organisation/resources/equipment"
    | "/_auth/_organisation/organisation/resources/labor"
    | "/_auth/_organisation/organisation/resources/other-costs"
    | "/_auth/_organisation/organisation/resources/subcontracting"
    | "/_auth/_organisation/organisation/resources/supply-families"
    | "/_auth/_organisation/organisation/resources/travel-costs"
    | "/_auth/_project/$projectId/$subProjectId/export-quote"
    | "/_auth/_project/$projectId/$subProjectId/sdp"
    | "/_auth/_project/$projectId/$subProjectId/sdp-config"
    | "/_auth/_project/bid-row-details/$projectId/$subProjectId"
    | "/_auth/_project/bid/$projectId/$subProjectId"
    | "/_auth/_project/import/$projectId/$subProjectId"
    | "/_auth/_project/indirect-costs/$projectId/$subProjectId"
    | "/_auth/_project/margin-optimization/$projectId/$subProjectId"
    | "/_auth/_project/purchases/$projectId/$subProjectId"
    | "/_auth/_project/summary/$projectId/$subProjectId"
    | "/_auth/_project/supplier-quote-request/$projectId/$subProjectId"
    | "/_auth/_project/tasks/$projectId/$subProjectId"
    | "/_auth/_deal/deals/$dealId/"
    | "/_auth/_frame/clients/$companyId/"
    | "/_auth/_frame/suppliers/$supplierId/"
    | "/_auth/_organisation/organisation/exports/"
    | "/_auth/_organisation/organisation/resources/"
    | "/_auth/_project/bid/$projectId/"
    | "/_auth/_deal/deals/$dealId/client-pricing-document_/import"
    | "/_auth/_deal/deals/$dealId/details/$subProjectId"
    | "/_auth/_deal/deals/$dealId/import/$subProjectId"
    | "/_auth/_project/bid-row-details/$projectId/$subProjectId/unassigned-work-packages"
    | "/_auth/_project/bid-row-details/$projectId/$subProjectId/work-packages"
    | "/_auth/_project/import_/$projectId/$subProjectId/link"
    | "/_auth/_project/margin-optimization/$projectId/$subProjectId/scenario"
    | "/_auth/_project/purchases/$projectId/$subProjectId/supplier-quote"
    | "/_auth/_project/supplier-quote-request/$projectId/$subProjectId/received-quotes"
    | "/_auth/_deal/deals/$dealId/details/"
    | "/_auth/_project/bid-row-details/$projectId/$subProjectId/"
    | "/_auth/_project/margin-optimization/$projectId/$subProjectId/"
    | "/_auth/_project/purchases/$projectId/$subProjectId/"
    | "/_auth/_project/supplier-quote-request/$projectId/$subProjectId/"
    | "/_auth/_deal/deals/$dealId/import_/$subProjectId/link"
    | "/_auth/_project/supplier-quote-request/$projectId/$subProjectId/content/$contentId";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren;
  No_authRoute: typeof No_authRouteWithChildren;
  MagicLinkRoute: typeof MagicLinkRoute;
  OnboardingRoute: typeof OnboardingRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/onboarding": {
      id: "/onboarding";
      path: "/onboarding";
      fullPath: "/onboarding";
      preLoaderRoute: typeof OnboardingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/magic-link": {
      id: "/magic-link";
      path: "/magic-link";
      fullPath: "/magic-link";
      preLoaderRoute: typeof MagicLinkRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_no_auth": {
      id: "/_no_auth";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof No_authRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_auth": {
      id: "/_auth";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AuthRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_no_auth/sign-up": {
      id: "/_no_auth/sign-up";
      path: "/sign-up";
      fullPath: "/sign-up";
      preLoaderRoute: typeof No_authSignUpRouteImport;
      parentRoute: typeof No_authRoute;
    };
    "/_no_auth/sign-in": {
      id: "/_no_auth/sign-in";
      path: "/sign-in";
      fullPath: "/sign-in";
      preLoaderRoute: typeof No_authSignInRouteImport;
      parentRoute: typeof No_authRoute;
    };
    "/_no_auth/reset-password": {
      id: "/_no_auth/reset-password";
      path: "/reset-password";
      fullPath: "/reset-password";
      preLoaderRoute: typeof No_authResetPasswordRouteImport;
      parentRoute: typeof No_authRoute;
    };
    "/_auth/_project": {
      id: "/_auth/_project";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AuthProjectRouteImport;
      parentRoute: typeof AuthRoute;
    };
    "/_auth/_organisation": {
      id: "/_auth/_organisation";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AuthOrganisationRouteImport;
      parentRoute: typeof AuthRoute;
    };
    "/_auth/_frame": {
      id: "/_auth/_frame";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AuthFrameRouteImport;
      parentRoute: typeof AuthRoute;
    };
    "/_auth/_deal": {
      id: "/_auth/_deal";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AuthDealRouteImport;
      parentRoute: typeof AuthRoute;
    };
    "/_auth/_frame/": {
      id: "/_auth/_frame/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof AuthFrameIndexRouteImport;
      parentRoute: typeof AuthFrameRoute;
    };
    "/_no_auth/sso-error/$": {
      id: "/_no_auth/sso-error/$";
      path: "/sso-error/$";
      fullPath: "/sso-error/$";
      preLoaderRoute: typeof No_authSsoErrorSplatRouteImport;
      parentRoute: typeof No_authRoute;
    };
    "/_auth/_organisation/organisation": {
      id: "/_auth/_organisation/organisation";
      path: "/organisation";
      fullPath: "/organisation";
      preLoaderRoute: typeof AuthOrganisationOrganisationRouteImport;
      parentRoute: typeof AuthOrganisationRoute;
    };
    "/_auth/_frame/welcome": {
      id: "/_auth/_frame/welcome";
      path: "/welcome";
      fullPath: "/welcome";
      preLoaderRoute: typeof AuthFrameWelcomeRouteImport;
      parentRoute: typeof AuthFrameRoute;
    };
    "/_auth/_frame/suppliers": {
      id: "/_auth/_frame/suppliers";
      path: "/suppliers";
      fullPath: "/suppliers";
      preLoaderRoute: typeof AuthFrameSuppliersRouteImport;
      parentRoute: typeof AuthFrameRoute;
    };
    "/_auth/_frame/storybook": {
      id: "/_auth/_frame/storybook";
      path: "/storybook";
      fullPath: "/storybook";
      preLoaderRoute: typeof AuthFrameStorybookRouteImport;
      parentRoute: typeof AuthFrameRoute;
    };
    "/_auth/_frame/steering": {
      id: "/_auth/_frame/steering";
      path: "/steering";
      fullPath: "/steering";
      preLoaderRoute: typeof AuthFrameSteeringRouteImport;
      parentRoute: typeof AuthFrameRoute;
    };
    "/_auth/_frame/library": {
      id: "/_auth/_frame/library";
      path: "/library";
      fullPath: "/library";
      preLoaderRoute: typeof AuthFrameLibraryRouteImport;
      parentRoute: typeof AuthFrameRoute;
    };
    "/_auth/_frame/karaoke": {
      id: "/_auth/_frame/karaoke";
      path: "/karaoke";
      fullPath: "/karaoke";
      preLoaderRoute: typeof AuthFrameKaraokeRouteImport;
      parentRoute: typeof AuthFrameRoute;
    };
    "/_auth/_frame/clients": {
      id: "/_auth/_frame/clients";
      path: "/clients";
      fullPath: "/clients";
      preLoaderRoute: typeof AuthFrameClientsRouteImport;
      parentRoute: typeof AuthFrameRoute;
    };
    "/_auth/_frame/abacus": {
      id: "/_auth/_frame/abacus";
      path: "/abacus";
      fullPath: "/abacus";
      preLoaderRoute: typeof AuthFrameAbacusRouteImport;
      parentRoute: typeof AuthFrameRoute;
    };
    "/_auth/_organisation/organisation/": {
      id: "/_auth/_organisation/organisation/";
      path: "/";
      fullPath: "/organisation/";
      preLoaderRoute: typeof AuthOrganisationOrganisationIndexRouteImport;
      parentRoute: typeof AuthOrganisationOrganisationRoute;
    };
    "/_auth/_frame/tenders/": {
      id: "/_auth/_frame/tenders/";
      path: "/tenders";
      fullPath: "/tenders/";
      preLoaderRoute: typeof AuthFrameTendersIndexRouteImport;
      parentRoute: typeof AuthFrameRoute;
    };
    "/_auth/_frame/suppliers/": {
      id: "/_auth/_frame/suppliers/";
      path: "/";
      fullPath: "/suppliers/";
      preLoaderRoute: typeof AuthFrameSuppliersIndexRouteImport;
      parentRoute: typeof AuthFrameSuppliersRoute;
    };
    "/_auth/_frame/storybook/": {
      id: "/_auth/_frame/storybook/";
      path: "/";
      fullPath: "/storybook/";
      preLoaderRoute: typeof AuthFrameStorybookIndexRouteImport;
      parentRoute: typeof AuthFrameStorybookRoute;
    };
    "/_auth/_frame/deals/": {
      id: "/_auth/_frame/deals/";
      path: "/deals";
      fullPath: "/deals/";
      preLoaderRoute: typeof AuthFrameDealsIndexRouteImport;
      parentRoute: typeof AuthFrameRoute;
    };
    "/_auth/_frame/clients/": {
      id: "/_auth/_frame/clients/";
      path: "/";
      fullPath: "/clients/";
      preLoaderRoute: typeof AuthFrameClientsIndexRouteImport;
      parentRoute: typeof AuthFrameClientsRoute;
    };
    "/_auth/_frame/chrono-devis/": {
      id: "/_auth/_frame/chrono-devis/";
      path: "/chrono-devis";
      fullPath: "/chrono-devis/";
      preLoaderRoute: typeof AuthFrameChronoDevisIndexRouteImport;
      parentRoute: typeof AuthFrameRoute;
    };
    "/_auth/_frame/admin/": {
      id: "/_auth/_frame/admin/";
      path: "/admin";
      fullPath: "/admin/";
      preLoaderRoute: typeof AuthFrameAdminIndexRouteImport;
      parentRoute: typeof AuthFrameRoute;
    };
    "/_auth/_organisation/organisation/resources": {
      id: "/_auth/_organisation/organisation/resources";
      path: "/resources";
      fullPath: "/organisation/resources";
      preLoaderRoute: typeof AuthOrganisationOrganisationResourcesRouteImport;
      parentRoute: typeof AuthOrganisationOrganisationRoute;
    };
    "/_auth/_organisation/organisation/quote-creation": {
      id: "/_auth/_organisation/organisation/quote-creation";
      path: "/quote-creation";
      fullPath: "/organisation/quote-creation";
      preLoaderRoute: typeof AuthOrganisationOrganisationQuoteCreationRouteImport;
      parentRoute: typeof AuthOrganisationOrganisationRoute;
    };
    "/_auth/_organisation/organisation/members": {
      id: "/_auth/_organisation/organisation/members";
      path: "/members";
      fullPath: "/organisation/members";
      preLoaderRoute: typeof AuthOrganisationOrganisationMembersRouteImport;
      parentRoute: typeof AuthOrganisationOrganisationRoute;
    };
    "/_auth/_organisation/organisation/exports": {
      id: "/_auth/_organisation/organisation/exports";
      path: "/exports";
      fullPath: "/organisation/exports";
      preLoaderRoute: typeof AuthOrganisationOrganisationExportsRouteImport;
      parentRoute: typeof AuthOrganisationOrganisationRoute;
    };
    "/_auth/_organisation/organisation/company-information": {
      id: "/_auth/_organisation/organisation/company-information";
      path: "/company-information";
      fullPath: "/organisation/company-information";
      preLoaderRoute: typeof AuthOrganisationOrganisationCompanyInformationRouteImport;
      parentRoute: typeof AuthOrganisationOrganisationRoute;
    };
    "/_auth/_frame/suppliers/contacts": {
      id: "/_auth/_frame/suppliers/contacts";
      path: "/contacts";
      fullPath: "/suppliers/contacts";
      preLoaderRoute: typeof AuthFrameSuppliersContactsRouteImport;
      parentRoute: typeof AuthFrameSuppliersRoute;
    };
    "/_auth/_frame/suppliers/$supplierId": {
      id: "/_auth/_frame/suppliers/$supplierId";
      path: "/$supplierId";
      fullPath: "/suppliers/$supplierId";
      preLoaderRoute: typeof AuthFrameSuppliersSupplierIdRouteImport;
      parentRoute: typeof AuthFrameSuppliersRoute;
    };
    "/_auth/_frame/storybook/content-layout": {
      id: "/_auth/_frame/storybook/content-layout";
      path: "/content-layout";
      fullPath: "/storybook/content-layout";
      preLoaderRoute: typeof AuthFrameStorybookContentLayoutRouteImport;
      parentRoute: typeof AuthFrameStorybookRoute;
    };
    "/_auth/_frame/clients/contacts": {
      id: "/_auth/_frame/clients/contacts";
      path: "/contacts";
      fullPath: "/clients/contacts";
      preLoaderRoute: typeof AuthFrameClientsContactsRouteImport;
      parentRoute: typeof AuthFrameClientsRoute;
    };
    "/_auth/_frame/clients/$companyId": {
      id: "/_auth/_frame/clients/$companyId";
      path: "/$companyId";
      fullPath: "/clients/$companyId";
      preLoaderRoute: typeof AuthFrameClientsCompanyIdRouteImport;
      parentRoute: typeof AuthFrameClientsRoute;
    };
    "/_auth/_frame/chrono-devis/internal-tracking": {
      id: "/_auth/_frame/chrono-devis/internal-tracking";
      path: "/chrono-devis/internal-tracking";
      fullPath: "/chrono-devis/internal-tracking";
      preLoaderRoute: typeof AuthFrameChronoDevisInternalTrackingRouteImport;
      parentRoute: typeof AuthFrameRoute;
    };
    "/_auth/_frame/admin/mail-test": {
      id: "/_auth/_frame/admin/mail-test";
      path: "/admin/mail-test";
      fullPath: "/admin/mail-test";
      preLoaderRoute: typeof AuthFrameAdminMailTestRouteImport;
      parentRoute: typeof AuthFrameRoute;
    };
    "/_auth/_deal/deals/$dealId": {
      id: "/_auth/_deal/deals/$dealId";
      path: "/deals/$dealId";
      fullPath: "/deals/$dealId";
      preLoaderRoute: typeof AuthDealDealsDealIdRouteImport;
      parentRoute: typeof AuthDealRoute;
    };
    "/_auth/_project/bid/$projectId/": {
      id: "/_auth/_project/bid/$projectId/";
      path: "/bid/$projectId";
      fullPath: "/bid/$projectId/";
      preLoaderRoute: typeof AuthProjectBidProjectIdIndexRouteImport;
      parentRoute: typeof AuthProjectRoute;
    };
    "/_auth/_organisation/organisation/resources/": {
      id: "/_auth/_organisation/organisation/resources/";
      path: "/";
      fullPath: "/organisation/resources/";
      preLoaderRoute: typeof AuthOrganisationOrganisationResourcesIndexRouteImport;
      parentRoute: typeof AuthOrganisationOrganisationResourcesRoute;
    };
    "/_auth/_organisation/organisation/exports/": {
      id: "/_auth/_organisation/organisation/exports/";
      path: "/";
      fullPath: "/organisation/exports/";
      preLoaderRoute: typeof AuthOrganisationOrganisationExportsIndexRouteImport;
      parentRoute: typeof AuthOrganisationOrganisationExportsRoute;
    };
    "/_auth/_frame/suppliers/$supplierId/": {
      id: "/_auth/_frame/suppliers/$supplierId/";
      path: "/";
      fullPath: "/suppliers/$supplierId/";
      preLoaderRoute: typeof AuthFrameSuppliersSupplierIdIndexRouteImport;
      parentRoute: typeof AuthFrameSuppliersSupplierIdRoute;
    };
    "/_auth/_frame/clients/$companyId/": {
      id: "/_auth/_frame/clients/$companyId/";
      path: "/";
      fullPath: "/clients/$companyId/";
      preLoaderRoute: typeof AuthFrameClientsCompanyIdIndexRouteImport;
      parentRoute: typeof AuthFrameClientsCompanyIdRoute;
    };
    "/_auth/_deal/deals/$dealId/": {
      id: "/_auth/_deal/deals/$dealId/";
      path: "/";
      fullPath: "/deals/$dealId/";
      preLoaderRoute: typeof AuthDealDealsDealIdIndexRouteImport;
      parentRoute: typeof AuthDealDealsDealIdRoute;
    };
    "/_auth/_project/tasks/$projectId/$subProjectId": {
      id: "/_auth/_project/tasks/$projectId/$subProjectId";
      path: "/tasks/$projectId/$subProjectId";
      fullPath: "/tasks/$projectId/$subProjectId";
      preLoaderRoute: typeof AuthProjectTasksProjectIdSubProjectIdRouteImport;
      parentRoute: typeof AuthProjectRoute;
    };
    "/_auth/_project/supplier-quote-request/$projectId/$subProjectId": {
      id: "/_auth/_project/supplier-quote-request/$projectId/$subProjectId";
      path: "/supplier-quote-request/$projectId/$subProjectId";
      fullPath: "/supplier-quote-request/$projectId/$subProjectId";
      preLoaderRoute: typeof AuthProjectSupplierQuoteRequestProjectIdSubProjectIdRouteImport;
      parentRoute: typeof AuthProjectRoute;
    };
    "/_auth/_project/summary/$projectId/$subProjectId": {
      id: "/_auth/_project/summary/$projectId/$subProjectId";
      path: "/summary/$projectId/$subProjectId";
      fullPath: "/summary/$projectId/$subProjectId";
      preLoaderRoute: typeof AuthProjectSummaryProjectIdSubProjectIdRouteImport;
      parentRoute: typeof AuthProjectRoute;
    };
    "/_auth/_project/purchases/$projectId/$subProjectId": {
      id: "/_auth/_project/purchases/$projectId/$subProjectId";
      path: "/purchases/$projectId/$subProjectId";
      fullPath: "/purchases/$projectId/$subProjectId";
      preLoaderRoute: typeof AuthProjectPurchasesProjectIdSubProjectIdRouteImport;
      parentRoute: typeof AuthProjectRoute;
    };
    "/_auth/_project/margin-optimization/$projectId/$subProjectId": {
      id: "/_auth/_project/margin-optimization/$projectId/$subProjectId";
      path: "/margin-optimization/$projectId/$subProjectId";
      fullPath: "/margin-optimization/$projectId/$subProjectId";
      preLoaderRoute: typeof AuthProjectMarginOptimizationProjectIdSubProjectIdRouteImport;
      parentRoute: typeof AuthProjectRoute;
    };
    "/_auth/_project/indirect-costs/$projectId/$subProjectId": {
      id: "/_auth/_project/indirect-costs/$projectId/$subProjectId";
      path: "/indirect-costs/$projectId/$subProjectId";
      fullPath: "/indirect-costs/$projectId/$subProjectId";
      preLoaderRoute: typeof AuthProjectIndirectCostsProjectIdSubProjectIdRouteImport;
      parentRoute: typeof AuthProjectRoute;
    };
    "/_auth/_project/import/$projectId/$subProjectId": {
      id: "/_auth/_project/import/$projectId/$subProjectId";
      path: "/import/$projectId/$subProjectId";
      fullPath: "/import/$projectId/$subProjectId";
      preLoaderRoute: typeof AuthProjectImportProjectIdSubProjectIdRouteImport;
      parentRoute: typeof AuthProjectRoute;
    };
    "/_auth/_project/bid/$projectId/$subProjectId": {
      id: "/_auth/_project/bid/$projectId/$subProjectId";
      path: "/bid/$projectId/$subProjectId";
      fullPath: "/bid/$projectId/$subProjectId";
      preLoaderRoute: typeof AuthProjectBidProjectIdSubProjectIdRouteImport;
      parentRoute: typeof AuthProjectRoute;
    };
    "/_auth/_project/bid-row-details/$projectId/$subProjectId": {
      id: "/_auth/_project/bid-row-details/$projectId/$subProjectId";
      path: "/bid-row-details/$projectId/$subProjectId";
      fullPath: "/bid-row-details/$projectId/$subProjectId";
      preLoaderRoute: typeof AuthProjectBidRowDetailsProjectIdSubProjectIdRouteImport;
      parentRoute: typeof AuthProjectRoute;
    };
    "/_auth/_project/$projectId/$subProjectId/sdp-config": {
      id: "/_auth/_project/$projectId/$subProjectId/sdp-config";
      path: "/$projectId/$subProjectId/sdp-config";
      fullPath: "/$projectId/$subProjectId/sdp-config";
      preLoaderRoute: typeof AuthProjectProjectIdSubProjectIdSdpConfigRouteImport;
      parentRoute: typeof AuthProjectRoute;
    };
    "/_auth/_project/$projectId/$subProjectId/sdp": {
      id: "/_auth/_project/$projectId/$subProjectId/sdp";
      path: "/$projectId/$subProjectId/sdp";
      fullPath: "/$projectId/$subProjectId/sdp";
      preLoaderRoute: typeof AuthProjectProjectIdSubProjectIdSdpRouteImport;
      parentRoute: typeof AuthProjectRoute;
    };
    "/_auth/_project/$projectId/$subProjectId/export-quote": {
      id: "/_auth/_project/$projectId/$subProjectId/export-quote";
      path: "/$projectId/$subProjectId/export-quote";
      fullPath: "/$projectId/$subProjectId/export-quote";
      preLoaderRoute: typeof AuthProjectProjectIdSubProjectIdExportQuoteRouteImport;
      parentRoute: typeof AuthProjectRoute;
    };
    "/_auth/_organisation/organisation/resources/travel-costs": {
      id: "/_auth/_organisation/organisation/resources/travel-costs";
      path: "/travel-costs";
      fullPath: "/organisation/resources/travel-costs";
      preLoaderRoute: typeof AuthOrganisationOrganisationResourcesTravelCostsRouteImport;
      parentRoute: typeof AuthOrganisationOrganisationResourcesRoute;
    };
    "/_auth/_organisation/organisation/resources/supply-families": {
      id: "/_auth/_organisation/organisation/resources/supply-families";
      path: "/supply-families";
      fullPath: "/organisation/resources/supply-families";
      preLoaderRoute: typeof AuthOrganisationOrganisationResourcesSupplyFamiliesRouteImport;
      parentRoute: typeof AuthOrganisationOrganisationResourcesRoute;
    };
    "/_auth/_organisation/organisation/resources/subcontracting": {
      id: "/_auth/_organisation/organisation/resources/subcontracting";
      path: "/subcontracting";
      fullPath: "/organisation/resources/subcontracting";
      preLoaderRoute: typeof AuthOrganisationOrganisationResourcesSubcontractingRouteImport;
      parentRoute: typeof AuthOrganisationOrganisationResourcesRoute;
    };
    "/_auth/_organisation/organisation/resources/other-costs": {
      id: "/_auth/_organisation/organisation/resources/other-costs";
      path: "/other-costs";
      fullPath: "/organisation/resources/other-costs";
      preLoaderRoute: typeof AuthOrganisationOrganisationResourcesOtherCostsRouteImport;
      parentRoute: typeof AuthOrganisationOrganisationResourcesRoute;
    };
    "/_auth/_organisation/organisation/resources/labor": {
      id: "/_auth/_organisation/organisation/resources/labor";
      path: "/labor";
      fullPath: "/organisation/resources/labor";
      preLoaderRoute: typeof AuthOrganisationOrganisationResourcesLaborRouteImport;
      parentRoute: typeof AuthOrganisationOrganisationResourcesRoute;
    };
    "/_auth/_organisation/organisation/resources/equipment": {
      id: "/_auth/_organisation/organisation/resources/equipment";
      path: "/equipment";
      fullPath: "/organisation/resources/equipment";
      preLoaderRoute: typeof AuthOrganisationOrganisationResourcesEquipmentRouteImport;
      parentRoute: typeof AuthOrganisationOrganisationResourcesRoute;
    };
    "/_auth/_organisation/organisation/resources/additional-costs": {
      id: "/_auth/_organisation/organisation/resources/additional-costs";
      path: "/additional-costs";
      fullPath: "/organisation/resources/additional-costs";
      preLoaderRoute: typeof AuthOrganisationOrganisationResourcesAdditionalCostsRouteImport;
      parentRoute: typeof AuthOrganisationOrganisationResourcesRoute;
    };
    "/_auth/_organisation/organisation/exports/quote-layout": {
      id: "/_auth/_organisation/organisation/exports/quote-layout";
      path: "/quote-layout";
      fullPath: "/organisation/exports/quote-layout";
      preLoaderRoute: typeof AuthOrganisationOrganisationExportsQuoteLayoutRouteImport;
      parentRoute: typeof AuthOrganisationOrganisationExportsRoute;
    };
    "/_auth/_organisation/organisation/exports/price-breakdown-coefficients": {
      id: "/_auth/_organisation/organisation/exports/price-breakdown-coefficients";
      path: "/price-breakdown-coefficients";
      fullPath: "/organisation/exports/price-breakdown-coefficients";
      preLoaderRoute: typeof AuthOrganisationOrganisationExportsPriceBreakdownCoefficientsRouteImport;
      parentRoute: typeof AuthOrganisationOrganisationExportsRoute;
    };
    "/_auth/_frame/suppliers/$supplierId/priced-deliverables": {
      id: "/_auth/_frame/suppliers/$supplierId/priced-deliverables";
      path: "/priced-deliverables";
      fullPath: "/suppliers/$supplierId/priced-deliverables";
      preLoaderRoute: typeof AuthFrameSuppliersSupplierIdPricedDeliverablesRouteImport;
      parentRoute: typeof AuthFrameSuppliersSupplierIdRoute;
    };
    "/_auth/_frame/suppliers/$supplierId/imported-catalog": {
      id: "/_auth/_frame/suppliers/$supplierId/imported-catalog";
      path: "/imported-catalog";
      fullPath: "/suppliers/$supplierId/imported-catalog";
      preLoaderRoute: typeof AuthFrameSuppliersSupplierIdImportedCatalogRouteImport;
      parentRoute: typeof AuthFrameSuppliersSupplierIdRoute;
    };
    "/_auth/_frame/suppliers/$supplierId/contacts": {
      id: "/_auth/_frame/suppliers/$supplierId/contacts";
      path: "/contacts";
      fullPath: "/suppliers/$supplierId/contacts";
      preLoaderRoute: typeof AuthFrameSuppliersSupplierIdContactsRouteImport;
      parentRoute: typeof AuthFrameSuppliersSupplierIdRoute;
    };
    "/_auth/_frame/suppliers/$supplierId/catalog-prices": {
      id: "/_auth/_frame/suppliers/$supplierId/catalog-prices";
      path: "/catalog-prices";
      fullPath: "/suppliers/$supplierId/catalog-prices";
      preLoaderRoute: typeof AuthFrameSuppliersSupplierIdCatalogPricesRouteImport;
      parentRoute: typeof AuthFrameSuppliersSupplierIdRoute;
    };
    "/_auth/_frame/clients/$companyId/projects": {
      id: "/_auth/_frame/clients/$companyId/projects";
      path: "/projects";
      fullPath: "/clients/$companyId/projects";
      preLoaderRoute: typeof AuthFrameClientsCompanyIdProjectsRouteImport;
      parentRoute: typeof AuthFrameClientsCompanyIdRoute;
    };
    "/_auth/_frame/clients/$companyId/contacts": {
      id: "/_auth/_frame/clients/$companyId/contacts";
      path: "/contacts";
      fullPath: "/clients/$companyId/contacts";
      preLoaderRoute: typeof AuthFrameClientsCompanyIdContactsRouteImport;
      parentRoute: typeof AuthFrameClientsCompanyIdRoute;
    };
    "/_auth/_deal/deals/$dealId/quotes": {
      id: "/_auth/_deal/deals/$dealId/quotes";
      path: "/quotes";
      fullPath: "/deals/$dealId/quotes";
      preLoaderRoute: typeof AuthDealDealsDealIdQuotesRouteImport;
      parentRoute: typeof AuthDealDealsDealIdRoute;
    };
    "/_auth/_deal/deals/$dealId/contractual-information": {
      id: "/_auth/_deal/deals/$dealId/contractual-information";
      path: "/contractual-information";
      fullPath: "/deals/$dealId/contractual-information";
      preLoaderRoute: typeof AuthDealDealsDealIdContractualInformationRouteImport;
      parentRoute: typeof AuthDealDealsDealIdRoute;
    };
    "/_auth/_deal/deals/$dealId/client-pricing-document": {
      id: "/_auth/_deal/deals/$dealId/client-pricing-document";
      path: "/client-pricing-document";
      fullPath: "/deals/$dealId/client-pricing-document";
      preLoaderRoute: typeof AuthDealDealsDealIdClientPricingDocumentRouteImport;
      parentRoute: typeof AuthDealDealsDealIdRoute;
    };
    "/_auth/_deal/deals/$dealId/analysis": {
      id: "/_auth/_deal/deals/$dealId/analysis";
      path: "/analysis";
      fullPath: "/deals/$dealId/analysis";
      preLoaderRoute: typeof AuthDealDealsDealIdAnalysisRouteImport;
      parentRoute: typeof AuthDealDealsDealIdRoute;
    };
    "/_auth/_project/supplier-quote-request/$projectId/$subProjectId/": {
      id: "/_auth/_project/supplier-quote-request/$projectId/$subProjectId/";
      path: "/";
      fullPath: "/supplier-quote-request/$projectId/$subProjectId/";
      preLoaderRoute: typeof AuthProjectSupplierQuoteRequestProjectIdSubProjectIdIndexRouteImport;
      parentRoute: typeof AuthProjectSupplierQuoteRequestProjectIdSubProjectIdRoute;
    };
    "/_auth/_project/purchases/$projectId/$subProjectId/": {
      id: "/_auth/_project/purchases/$projectId/$subProjectId/";
      path: "/";
      fullPath: "/purchases/$projectId/$subProjectId/";
      preLoaderRoute: typeof AuthProjectPurchasesProjectIdSubProjectIdIndexRouteImport;
      parentRoute: typeof AuthProjectPurchasesProjectIdSubProjectIdRoute;
    };
    "/_auth/_project/margin-optimization/$projectId/$subProjectId/": {
      id: "/_auth/_project/margin-optimization/$projectId/$subProjectId/";
      path: "/";
      fullPath: "/margin-optimization/$projectId/$subProjectId/";
      preLoaderRoute: typeof AuthProjectMarginOptimizationProjectIdSubProjectIdIndexRouteImport;
      parentRoute: typeof AuthProjectMarginOptimizationProjectIdSubProjectIdRoute;
    };
    "/_auth/_project/bid-row-details/$projectId/$subProjectId/": {
      id: "/_auth/_project/bid-row-details/$projectId/$subProjectId/";
      path: "/";
      fullPath: "/bid-row-details/$projectId/$subProjectId/";
      preLoaderRoute: typeof AuthProjectBidRowDetailsProjectIdSubProjectIdIndexRouteImport;
      parentRoute: typeof AuthProjectBidRowDetailsProjectIdSubProjectIdRoute;
    };
    "/_auth/_deal/deals/$dealId/details/": {
      id: "/_auth/_deal/deals/$dealId/details/";
      path: "/details";
      fullPath: "/deals/$dealId/details/";
      preLoaderRoute: typeof AuthDealDealsDealIdDetailsIndexRouteImport;
      parentRoute: typeof AuthDealDealsDealIdRoute;
    };
    "/_auth/_project/supplier-quote-request/$projectId/$subProjectId/received-quotes": {
      id: "/_auth/_project/supplier-quote-request/$projectId/$subProjectId/received-quotes";
      path: "/received-quotes";
      fullPath: "/supplier-quote-request/$projectId/$subProjectId/received-quotes";
      preLoaderRoute: typeof AuthProjectSupplierQuoteRequestProjectIdSubProjectIdReceivedQuotesRouteImport;
      parentRoute: typeof AuthProjectSupplierQuoteRequestProjectIdSubProjectIdRoute;
    };
    "/_auth/_project/purchases/$projectId/$subProjectId/supplier-quote": {
      id: "/_auth/_project/purchases/$projectId/$subProjectId/supplier-quote";
      path: "/supplier-quote";
      fullPath: "/purchases/$projectId/$subProjectId/supplier-quote";
      preLoaderRoute: typeof AuthProjectPurchasesProjectIdSubProjectIdSupplierQuoteRouteImport;
      parentRoute: typeof AuthProjectPurchasesProjectIdSubProjectIdRoute;
    };
    "/_auth/_project/margin-optimization/$projectId/$subProjectId/scenario": {
      id: "/_auth/_project/margin-optimization/$projectId/$subProjectId/scenario";
      path: "/scenario";
      fullPath: "/margin-optimization/$projectId/$subProjectId/scenario";
      preLoaderRoute: typeof AuthProjectMarginOptimizationProjectIdSubProjectIdScenarioRouteImport;
      parentRoute: typeof AuthProjectMarginOptimizationProjectIdSubProjectIdRoute;
    };
    "/_auth/_project/import_/$projectId/$subProjectId/link": {
      id: "/_auth/_project/import_/$projectId/$subProjectId/link";
      path: "/import/$projectId/$subProjectId/link";
      fullPath: "/import/$projectId/$subProjectId/link";
      preLoaderRoute: typeof AuthProjectImportProjectIdSubProjectIdLinkRouteImport;
      parentRoute: typeof AuthProjectRoute;
    };
    "/_auth/_project/bid-row-details/$projectId/$subProjectId/work-packages": {
      id: "/_auth/_project/bid-row-details/$projectId/$subProjectId/work-packages";
      path: "/work-packages";
      fullPath: "/bid-row-details/$projectId/$subProjectId/work-packages";
      preLoaderRoute: typeof AuthProjectBidRowDetailsProjectIdSubProjectIdWorkPackagesRouteImport;
      parentRoute: typeof AuthProjectBidRowDetailsProjectIdSubProjectIdRoute;
    };
    "/_auth/_project/bid-row-details/$projectId/$subProjectId/unassigned-work-packages": {
      id: "/_auth/_project/bid-row-details/$projectId/$subProjectId/unassigned-work-packages";
      path: "/unassigned-work-packages";
      fullPath: "/bid-row-details/$projectId/$subProjectId/unassigned-work-packages";
      preLoaderRoute: typeof AuthProjectBidRowDetailsProjectIdSubProjectIdUnassignedWorkPackagesRouteImport;
      parentRoute: typeof AuthProjectBidRowDetailsProjectIdSubProjectIdRoute;
    };
    "/_auth/_deal/deals/$dealId/import/$subProjectId": {
      id: "/_auth/_deal/deals/$dealId/import/$subProjectId";
      path: "/import/$subProjectId";
      fullPath: "/deals/$dealId/import/$subProjectId";
      preLoaderRoute: typeof AuthDealDealsDealIdImportSubProjectIdRouteImport;
      parentRoute: typeof AuthDealDealsDealIdRoute;
    };
    "/_auth/_deal/deals/$dealId/details/$subProjectId": {
      id: "/_auth/_deal/deals/$dealId/details/$subProjectId";
      path: "/details/$subProjectId";
      fullPath: "/deals/$dealId/details/$subProjectId";
      preLoaderRoute: typeof AuthDealDealsDealIdDetailsSubProjectIdRouteImport;
      parentRoute: typeof AuthDealDealsDealIdRoute;
    };
    "/_auth/_deal/deals/$dealId/client-pricing-document_/import": {
      id: "/_auth/_deal/deals/$dealId/client-pricing-document_/import";
      path: "/client-pricing-document/import";
      fullPath: "/deals/$dealId/client-pricing-document/import";
      preLoaderRoute: typeof AuthDealDealsDealIdClientPricingDocumentImportRouteImport;
      parentRoute: typeof AuthDealDealsDealIdRoute;
    };
    "/_auth/_project/supplier-quote-request/$projectId/$subProjectId/content/$contentId": {
      id: "/_auth/_project/supplier-quote-request/$projectId/$subProjectId/content/$contentId";
      path: "/content/$contentId";
      fullPath: "/supplier-quote-request/$projectId/$subProjectId/content/$contentId";
      preLoaderRoute: typeof AuthProjectSupplierQuoteRequestProjectIdSubProjectIdContentContentIdRouteImport;
      parentRoute: typeof AuthProjectSupplierQuoteRequestProjectIdSubProjectIdRoute;
    };
    "/_auth/_deal/deals/$dealId/import_/$subProjectId/link": {
      id: "/_auth/_deal/deals/$dealId/import_/$subProjectId/link";
      path: "/import/$subProjectId/link";
      fullPath: "/deals/$dealId/import/$subProjectId/link";
      preLoaderRoute: typeof AuthDealDealsDealIdImportSubProjectIdLinkRouteImport;
      parentRoute: typeof AuthDealDealsDealIdRoute;
    };
  }
}

interface AuthDealDealsDealIdRouteChildren {
  AuthDealDealsDealIdAnalysisRoute: typeof AuthDealDealsDealIdAnalysisRoute;
  AuthDealDealsDealIdClientPricingDocumentRoute: typeof AuthDealDealsDealIdClientPricingDocumentRoute;
  AuthDealDealsDealIdContractualInformationRoute: typeof AuthDealDealsDealIdContractualInformationRoute;
  AuthDealDealsDealIdQuotesRoute: typeof AuthDealDealsDealIdQuotesRoute;
  AuthDealDealsDealIdIndexRoute: typeof AuthDealDealsDealIdIndexRoute;
  AuthDealDealsDealIdClientPricingDocumentImportRoute: typeof AuthDealDealsDealIdClientPricingDocumentImportRoute;
  AuthDealDealsDealIdDetailsSubProjectIdRoute: typeof AuthDealDealsDealIdDetailsSubProjectIdRoute;
  AuthDealDealsDealIdImportSubProjectIdRoute: typeof AuthDealDealsDealIdImportSubProjectIdRoute;
  AuthDealDealsDealIdDetailsIndexRoute: typeof AuthDealDealsDealIdDetailsIndexRoute;
  AuthDealDealsDealIdImportSubProjectIdLinkRoute: typeof AuthDealDealsDealIdImportSubProjectIdLinkRoute;
}

const AuthDealDealsDealIdRouteChildren: AuthDealDealsDealIdRouteChildren = {
  AuthDealDealsDealIdAnalysisRoute: AuthDealDealsDealIdAnalysisRoute,
  AuthDealDealsDealIdClientPricingDocumentRoute:
    AuthDealDealsDealIdClientPricingDocumentRoute,
  AuthDealDealsDealIdContractualInformationRoute:
    AuthDealDealsDealIdContractualInformationRoute,
  AuthDealDealsDealIdQuotesRoute: AuthDealDealsDealIdQuotesRoute,
  AuthDealDealsDealIdIndexRoute: AuthDealDealsDealIdIndexRoute,
  AuthDealDealsDealIdClientPricingDocumentImportRoute:
    AuthDealDealsDealIdClientPricingDocumentImportRoute,
  AuthDealDealsDealIdDetailsSubProjectIdRoute:
    AuthDealDealsDealIdDetailsSubProjectIdRoute,
  AuthDealDealsDealIdImportSubProjectIdRoute:
    AuthDealDealsDealIdImportSubProjectIdRoute,
  AuthDealDealsDealIdDetailsIndexRoute: AuthDealDealsDealIdDetailsIndexRoute,
  AuthDealDealsDealIdImportSubProjectIdLinkRoute:
    AuthDealDealsDealIdImportSubProjectIdLinkRoute,
};

const AuthDealDealsDealIdRouteWithChildren =
  AuthDealDealsDealIdRoute._addFileChildren(AuthDealDealsDealIdRouteChildren);

interface AuthDealRouteChildren {
  AuthDealDealsDealIdRoute: typeof AuthDealDealsDealIdRouteWithChildren;
}

const AuthDealRouteChildren: AuthDealRouteChildren = {
  AuthDealDealsDealIdRoute: AuthDealDealsDealIdRouteWithChildren,
};

const AuthDealRouteWithChildren = AuthDealRoute._addFileChildren(
  AuthDealRouteChildren,
);

interface AuthFrameClientsCompanyIdRouteChildren {
  AuthFrameClientsCompanyIdContactsRoute: typeof AuthFrameClientsCompanyIdContactsRoute;
  AuthFrameClientsCompanyIdProjectsRoute: typeof AuthFrameClientsCompanyIdProjectsRoute;
  AuthFrameClientsCompanyIdIndexRoute: typeof AuthFrameClientsCompanyIdIndexRoute;
}

const AuthFrameClientsCompanyIdRouteChildren: AuthFrameClientsCompanyIdRouteChildren =
  {
    AuthFrameClientsCompanyIdContactsRoute:
      AuthFrameClientsCompanyIdContactsRoute,
    AuthFrameClientsCompanyIdProjectsRoute:
      AuthFrameClientsCompanyIdProjectsRoute,
    AuthFrameClientsCompanyIdIndexRoute: AuthFrameClientsCompanyIdIndexRoute,
  };

const AuthFrameClientsCompanyIdRouteWithChildren =
  AuthFrameClientsCompanyIdRoute._addFileChildren(
    AuthFrameClientsCompanyIdRouteChildren,
  );

interface AuthFrameClientsRouteChildren {
  AuthFrameClientsCompanyIdRoute: typeof AuthFrameClientsCompanyIdRouteWithChildren;
  AuthFrameClientsContactsRoute: typeof AuthFrameClientsContactsRoute;
  AuthFrameClientsIndexRoute: typeof AuthFrameClientsIndexRoute;
}

const AuthFrameClientsRouteChildren: AuthFrameClientsRouteChildren = {
  AuthFrameClientsCompanyIdRoute: AuthFrameClientsCompanyIdRouteWithChildren,
  AuthFrameClientsContactsRoute: AuthFrameClientsContactsRoute,
  AuthFrameClientsIndexRoute: AuthFrameClientsIndexRoute,
};

const AuthFrameClientsRouteWithChildren =
  AuthFrameClientsRoute._addFileChildren(AuthFrameClientsRouteChildren);

interface AuthFrameStorybookRouteChildren {
  AuthFrameStorybookContentLayoutRoute: typeof AuthFrameStorybookContentLayoutRoute;
  AuthFrameStorybookIndexRoute: typeof AuthFrameStorybookIndexRoute;
}

const AuthFrameStorybookRouteChildren: AuthFrameStorybookRouteChildren = {
  AuthFrameStorybookContentLayoutRoute: AuthFrameStorybookContentLayoutRoute,
  AuthFrameStorybookIndexRoute: AuthFrameStorybookIndexRoute,
};

const AuthFrameStorybookRouteWithChildren =
  AuthFrameStorybookRoute._addFileChildren(AuthFrameStorybookRouteChildren);

interface AuthFrameSuppliersSupplierIdRouteChildren {
  AuthFrameSuppliersSupplierIdCatalogPricesRoute: typeof AuthFrameSuppliersSupplierIdCatalogPricesRoute;
  AuthFrameSuppliersSupplierIdContactsRoute: typeof AuthFrameSuppliersSupplierIdContactsRoute;
  AuthFrameSuppliersSupplierIdImportedCatalogRoute: typeof AuthFrameSuppliersSupplierIdImportedCatalogRoute;
  AuthFrameSuppliersSupplierIdPricedDeliverablesRoute: typeof AuthFrameSuppliersSupplierIdPricedDeliverablesRoute;
  AuthFrameSuppliersSupplierIdIndexRoute: typeof AuthFrameSuppliersSupplierIdIndexRoute;
}

const AuthFrameSuppliersSupplierIdRouteChildren: AuthFrameSuppliersSupplierIdRouteChildren =
  {
    AuthFrameSuppliersSupplierIdCatalogPricesRoute:
      AuthFrameSuppliersSupplierIdCatalogPricesRoute,
    AuthFrameSuppliersSupplierIdContactsRoute:
      AuthFrameSuppliersSupplierIdContactsRoute,
    AuthFrameSuppliersSupplierIdImportedCatalogRoute:
      AuthFrameSuppliersSupplierIdImportedCatalogRoute,
    AuthFrameSuppliersSupplierIdPricedDeliverablesRoute:
      AuthFrameSuppliersSupplierIdPricedDeliverablesRoute,
    AuthFrameSuppliersSupplierIdIndexRoute:
      AuthFrameSuppliersSupplierIdIndexRoute,
  };

const AuthFrameSuppliersSupplierIdRouteWithChildren =
  AuthFrameSuppliersSupplierIdRoute._addFileChildren(
    AuthFrameSuppliersSupplierIdRouteChildren,
  );

interface AuthFrameSuppliersRouteChildren {
  AuthFrameSuppliersSupplierIdRoute: typeof AuthFrameSuppliersSupplierIdRouteWithChildren;
  AuthFrameSuppliersContactsRoute: typeof AuthFrameSuppliersContactsRoute;
  AuthFrameSuppliersIndexRoute: typeof AuthFrameSuppliersIndexRoute;
}

const AuthFrameSuppliersRouteChildren: AuthFrameSuppliersRouteChildren = {
  AuthFrameSuppliersSupplierIdRoute:
    AuthFrameSuppliersSupplierIdRouteWithChildren,
  AuthFrameSuppliersContactsRoute: AuthFrameSuppliersContactsRoute,
  AuthFrameSuppliersIndexRoute: AuthFrameSuppliersIndexRoute,
};

const AuthFrameSuppliersRouteWithChildren =
  AuthFrameSuppliersRoute._addFileChildren(AuthFrameSuppliersRouteChildren);

interface AuthFrameRouteChildren {
  AuthFrameAbacusRoute: typeof AuthFrameAbacusRoute;
  AuthFrameClientsRoute: typeof AuthFrameClientsRouteWithChildren;
  AuthFrameKaraokeRoute: typeof AuthFrameKaraokeRoute;
  AuthFrameLibraryRoute: typeof AuthFrameLibraryRoute;
  AuthFrameSteeringRoute: typeof AuthFrameSteeringRoute;
  AuthFrameStorybookRoute: typeof AuthFrameStorybookRouteWithChildren;
  AuthFrameSuppliersRoute: typeof AuthFrameSuppliersRouteWithChildren;
  AuthFrameWelcomeRoute: typeof AuthFrameWelcomeRoute;
  AuthFrameIndexRoute: typeof AuthFrameIndexRoute;
  AuthFrameAdminMailTestRoute: typeof AuthFrameAdminMailTestRoute;
  AuthFrameChronoDevisInternalTrackingRoute: typeof AuthFrameChronoDevisInternalTrackingRoute;
  AuthFrameAdminIndexRoute: typeof AuthFrameAdminIndexRoute;
  AuthFrameChronoDevisIndexRoute: typeof AuthFrameChronoDevisIndexRoute;
  AuthFrameDealsIndexRoute: typeof AuthFrameDealsIndexRoute;
  AuthFrameTendersIndexRoute: typeof AuthFrameTendersIndexRoute;
}

const AuthFrameRouteChildren: AuthFrameRouteChildren = {
  AuthFrameAbacusRoute: AuthFrameAbacusRoute,
  AuthFrameClientsRoute: AuthFrameClientsRouteWithChildren,
  AuthFrameKaraokeRoute: AuthFrameKaraokeRoute,
  AuthFrameLibraryRoute: AuthFrameLibraryRoute,
  AuthFrameSteeringRoute: AuthFrameSteeringRoute,
  AuthFrameStorybookRoute: AuthFrameStorybookRouteWithChildren,
  AuthFrameSuppliersRoute: AuthFrameSuppliersRouteWithChildren,
  AuthFrameWelcomeRoute: AuthFrameWelcomeRoute,
  AuthFrameIndexRoute: AuthFrameIndexRoute,
  AuthFrameAdminMailTestRoute: AuthFrameAdminMailTestRoute,
  AuthFrameChronoDevisInternalTrackingRoute:
    AuthFrameChronoDevisInternalTrackingRoute,
  AuthFrameAdminIndexRoute: AuthFrameAdminIndexRoute,
  AuthFrameChronoDevisIndexRoute: AuthFrameChronoDevisIndexRoute,
  AuthFrameDealsIndexRoute: AuthFrameDealsIndexRoute,
  AuthFrameTendersIndexRoute: AuthFrameTendersIndexRoute,
};

const AuthFrameRouteWithChildren = AuthFrameRoute._addFileChildren(
  AuthFrameRouteChildren,
);

interface AuthOrganisationOrganisationExportsRouteChildren {
  AuthOrganisationOrganisationExportsPriceBreakdownCoefficientsRoute: typeof AuthOrganisationOrganisationExportsPriceBreakdownCoefficientsRoute;
  AuthOrganisationOrganisationExportsQuoteLayoutRoute: typeof AuthOrganisationOrganisationExportsQuoteLayoutRoute;
  AuthOrganisationOrganisationExportsIndexRoute: typeof AuthOrganisationOrganisationExportsIndexRoute;
}

const AuthOrganisationOrganisationExportsRouteChildren: AuthOrganisationOrganisationExportsRouteChildren =
  {
    AuthOrganisationOrganisationExportsPriceBreakdownCoefficientsRoute:
      AuthOrganisationOrganisationExportsPriceBreakdownCoefficientsRoute,
    AuthOrganisationOrganisationExportsQuoteLayoutRoute:
      AuthOrganisationOrganisationExportsQuoteLayoutRoute,
    AuthOrganisationOrganisationExportsIndexRoute:
      AuthOrganisationOrganisationExportsIndexRoute,
  };

const AuthOrganisationOrganisationExportsRouteWithChildren =
  AuthOrganisationOrganisationExportsRoute._addFileChildren(
    AuthOrganisationOrganisationExportsRouteChildren,
  );

interface AuthOrganisationOrganisationResourcesRouteChildren {
  AuthOrganisationOrganisationResourcesAdditionalCostsRoute: typeof AuthOrganisationOrganisationResourcesAdditionalCostsRoute;
  AuthOrganisationOrganisationResourcesEquipmentRoute: typeof AuthOrganisationOrganisationResourcesEquipmentRoute;
  AuthOrganisationOrganisationResourcesLaborRoute: typeof AuthOrganisationOrganisationResourcesLaborRoute;
  AuthOrganisationOrganisationResourcesOtherCostsRoute: typeof AuthOrganisationOrganisationResourcesOtherCostsRoute;
  AuthOrganisationOrganisationResourcesSubcontractingRoute: typeof AuthOrganisationOrganisationResourcesSubcontractingRoute;
  AuthOrganisationOrganisationResourcesSupplyFamiliesRoute: typeof AuthOrganisationOrganisationResourcesSupplyFamiliesRoute;
  AuthOrganisationOrganisationResourcesTravelCostsRoute: typeof AuthOrganisationOrganisationResourcesTravelCostsRoute;
  AuthOrganisationOrganisationResourcesIndexRoute: typeof AuthOrganisationOrganisationResourcesIndexRoute;
}

const AuthOrganisationOrganisationResourcesRouteChildren: AuthOrganisationOrganisationResourcesRouteChildren =
  {
    AuthOrganisationOrganisationResourcesAdditionalCostsRoute:
      AuthOrganisationOrganisationResourcesAdditionalCostsRoute,
    AuthOrganisationOrganisationResourcesEquipmentRoute:
      AuthOrganisationOrganisationResourcesEquipmentRoute,
    AuthOrganisationOrganisationResourcesLaborRoute:
      AuthOrganisationOrganisationResourcesLaborRoute,
    AuthOrganisationOrganisationResourcesOtherCostsRoute:
      AuthOrganisationOrganisationResourcesOtherCostsRoute,
    AuthOrganisationOrganisationResourcesSubcontractingRoute:
      AuthOrganisationOrganisationResourcesSubcontractingRoute,
    AuthOrganisationOrganisationResourcesSupplyFamiliesRoute:
      AuthOrganisationOrganisationResourcesSupplyFamiliesRoute,
    AuthOrganisationOrganisationResourcesTravelCostsRoute:
      AuthOrganisationOrganisationResourcesTravelCostsRoute,
    AuthOrganisationOrganisationResourcesIndexRoute:
      AuthOrganisationOrganisationResourcesIndexRoute,
  };

const AuthOrganisationOrganisationResourcesRouteWithChildren =
  AuthOrganisationOrganisationResourcesRoute._addFileChildren(
    AuthOrganisationOrganisationResourcesRouteChildren,
  );

interface AuthOrganisationOrganisationRouteChildren {
  AuthOrganisationOrganisationCompanyInformationRoute: typeof AuthOrganisationOrganisationCompanyInformationRoute;
  AuthOrganisationOrganisationExportsRoute: typeof AuthOrganisationOrganisationExportsRouteWithChildren;
  AuthOrganisationOrganisationMembersRoute: typeof AuthOrganisationOrganisationMembersRoute;
  AuthOrganisationOrganisationQuoteCreationRoute: typeof AuthOrganisationOrganisationQuoteCreationRoute;
  AuthOrganisationOrganisationResourcesRoute: typeof AuthOrganisationOrganisationResourcesRouteWithChildren;
  AuthOrganisationOrganisationIndexRoute: typeof AuthOrganisationOrganisationIndexRoute;
}

const AuthOrganisationOrganisationRouteChildren: AuthOrganisationOrganisationRouteChildren =
  {
    AuthOrganisationOrganisationCompanyInformationRoute:
      AuthOrganisationOrganisationCompanyInformationRoute,
    AuthOrganisationOrganisationExportsRoute:
      AuthOrganisationOrganisationExportsRouteWithChildren,
    AuthOrganisationOrganisationMembersRoute:
      AuthOrganisationOrganisationMembersRoute,
    AuthOrganisationOrganisationQuoteCreationRoute:
      AuthOrganisationOrganisationQuoteCreationRoute,
    AuthOrganisationOrganisationResourcesRoute:
      AuthOrganisationOrganisationResourcesRouteWithChildren,
    AuthOrganisationOrganisationIndexRoute:
      AuthOrganisationOrganisationIndexRoute,
  };

const AuthOrganisationOrganisationRouteWithChildren =
  AuthOrganisationOrganisationRoute._addFileChildren(
    AuthOrganisationOrganisationRouteChildren,
  );

interface AuthOrganisationRouteChildren {
  AuthOrganisationOrganisationRoute: typeof AuthOrganisationOrganisationRouteWithChildren;
}

const AuthOrganisationRouteChildren: AuthOrganisationRouteChildren = {
  AuthOrganisationOrganisationRoute:
    AuthOrganisationOrganisationRouteWithChildren,
};

const AuthOrganisationRouteWithChildren =
  AuthOrganisationRoute._addFileChildren(AuthOrganisationRouteChildren);

interface AuthProjectBidRowDetailsProjectIdSubProjectIdRouteChildren {
  AuthProjectBidRowDetailsProjectIdSubProjectIdUnassignedWorkPackagesRoute: typeof AuthProjectBidRowDetailsProjectIdSubProjectIdUnassignedWorkPackagesRoute;
  AuthProjectBidRowDetailsProjectIdSubProjectIdWorkPackagesRoute: typeof AuthProjectBidRowDetailsProjectIdSubProjectIdWorkPackagesRoute;
  AuthProjectBidRowDetailsProjectIdSubProjectIdIndexRoute: typeof AuthProjectBidRowDetailsProjectIdSubProjectIdIndexRoute;
}

const AuthProjectBidRowDetailsProjectIdSubProjectIdRouteChildren: AuthProjectBidRowDetailsProjectIdSubProjectIdRouteChildren =
  {
    AuthProjectBidRowDetailsProjectIdSubProjectIdUnassignedWorkPackagesRoute:
      AuthProjectBidRowDetailsProjectIdSubProjectIdUnassignedWorkPackagesRoute,
    AuthProjectBidRowDetailsProjectIdSubProjectIdWorkPackagesRoute:
      AuthProjectBidRowDetailsProjectIdSubProjectIdWorkPackagesRoute,
    AuthProjectBidRowDetailsProjectIdSubProjectIdIndexRoute:
      AuthProjectBidRowDetailsProjectIdSubProjectIdIndexRoute,
  };

const AuthProjectBidRowDetailsProjectIdSubProjectIdRouteWithChildren =
  AuthProjectBidRowDetailsProjectIdSubProjectIdRoute._addFileChildren(
    AuthProjectBidRowDetailsProjectIdSubProjectIdRouteChildren,
  );

interface AuthProjectMarginOptimizationProjectIdSubProjectIdRouteChildren {
  AuthProjectMarginOptimizationProjectIdSubProjectIdScenarioRoute: typeof AuthProjectMarginOptimizationProjectIdSubProjectIdScenarioRoute;
  AuthProjectMarginOptimizationProjectIdSubProjectIdIndexRoute: typeof AuthProjectMarginOptimizationProjectIdSubProjectIdIndexRoute;
}

const AuthProjectMarginOptimizationProjectIdSubProjectIdRouteChildren: AuthProjectMarginOptimizationProjectIdSubProjectIdRouteChildren =
  {
    AuthProjectMarginOptimizationProjectIdSubProjectIdScenarioRoute:
      AuthProjectMarginOptimizationProjectIdSubProjectIdScenarioRoute,
    AuthProjectMarginOptimizationProjectIdSubProjectIdIndexRoute:
      AuthProjectMarginOptimizationProjectIdSubProjectIdIndexRoute,
  };

const AuthProjectMarginOptimizationProjectIdSubProjectIdRouteWithChildren =
  AuthProjectMarginOptimizationProjectIdSubProjectIdRoute._addFileChildren(
    AuthProjectMarginOptimizationProjectIdSubProjectIdRouteChildren,
  );

interface AuthProjectPurchasesProjectIdSubProjectIdRouteChildren {
  AuthProjectPurchasesProjectIdSubProjectIdSupplierQuoteRoute: typeof AuthProjectPurchasesProjectIdSubProjectIdSupplierQuoteRoute;
  AuthProjectPurchasesProjectIdSubProjectIdIndexRoute: typeof AuthProjectPurchasesProjectIdSubProjectIdIndexRoute;
}

const AuthProjectPurchasesProjectIdSubProjectIdRouteChildren: AuthProjectPurchasesProjectIdSubProjectIdRouteChildren =
  {
    AuthProjectPurchasesProjectIdSubProjectIdSupplierQuoteRoute:
      AuthProjectPurchasesProjectIdSubProjectIdSupplierQuoteRoute,
    AuthProjectPurchasesProjectIdSubProjectIdIndexRoute:
      AuthProjectPurchasesProjectIdSubProjectIdIndexRoute,
  };

const AuthProjectPurchasesProjectIdSubProjectIdRouteWithChildren =
  AuthProjectPurchasesProjectIdSubProjectIdRoute._addFileChildren(
    AuthProjectPurchasesProjectIdSubProjectIdRouteChildren,
  );

interface AuthProjectSupplierQuoteRequestProjectIdSubProjectIdRouteChildren {
  AuthProjectSupplierQuoteRequestProjectIdSubProjectIdReceivedQuotesRoute: typeof AuthProjectSupplierQuoteRequestProjectIdSubProjectIdReceivedQuotesRoute;
  AuthProjectSupplierQuoteRequestProjectIdSubProjectIdIndexRoute: typeof AuthProjectSupplierQuoteRequestProjectIdSubProjectIdIndexRoute;
  AuthProjectSupplierQuoteRequestProjectIdSubProjectIdContentContentIdRoute: typeof AuthProjectSupplierQuoteRequestProjectIdSubProjectIdContentContentIdRoute;
}

const AuthProjectSupplierQuoteRequestProjectIdSubProjectIdRouteChildren: AuthProjectSupplierQuoteRequestProjectIdSubProjectIdRouteChildren =
  {
    AuthProjectSupplierQuoteRequestProjectIdSubProjectIdReceivedQuotesRoute:
      AuthProjectSupplierQuoteRequestProjectIdSubProjectIdReceivedQuotesRoute,
    AuthProjectSupplierQuoteRequestProjectIdSubProjectIdIndexRoute:
      AuthProjectSupplierQuoteRequestProjectIdSubProjectIdIndexRoute,
    AuthProjectSupplierQuoteRequestProjectIdSubProjectIdContentContentIdRoute:
      AuthProjectSupplierQuoteRequestProjectIdSubProjectIdContentContentIdRoute,
  };

const AuthProjectSupplierQuoteRequestProjectIdSubProjectIdRouteWithChildren =
  AuthProjectSupplierQuoteRequestProjectIdSubProjectIdRoute._addFileChildren(
    AuthProjectSupplierQuoteRequestProjectIdSubProjectIdRouteChildren,
  );

interface AuthProjectRouteChildren {
  AuthProjectProjectIdSubProjectIdExportQuoteRoute: typeof AuthProjectProjectIdSubProjectIdExportQuoteRoute;
  AuthProjectProjectIdSubProjectIdSdpRoute: typeof AuthProjectProjectIdSubProjectIdSdpRoute;
  AuthProjectProjectIdSubProjectIdSdpConfigRoute: typeof AuthProjectProjectIdSubProjectIdSdpConfigRoute;
  AuthProjectBidRowDetailsProjectIdSubProjectIdRoute: typeof AuthProjectBidRowDetailsProjectIdSubProjectIdRouteWithChildren;
  AuthProjectBidProjectIdSubProjectIdRoute: typeof AuthProjectBidProjectIdSubProjectIdRoute;
  AuthProjectImportProjectIdSubProjectIdRoute: typeof AuthProjectImportProjectIdSubProjectIdRoute;
  AuthProjectIndirectCostsProjectIdSubProjectIdRoute: typeof AuthProjectIndirectCostsProjectIdSubProjectIdRoute;
  AuthProjectMarginOptimizationProjectIdSubProjectIdRoute: typeof AuthProjectMarginOptimizationProjectIdSubProjectIdRouteWithChildren;
  AuthProjectPurchasesProjectIdSubProjectIdRoute: typeof AuthProjectPurchasesProjectIdSubProjectIdRouteWithChildren;
  AuthProjectSummaryProjectIdSubProjectIdRoute: typeof AuthProjectSummaryProjectIdSubProjectIdRoute;
  AuthProjectSupplierQuoteRequestProjectIdSubProjectIdRoute: typeof AuthProjectSupplierQuoteRequestProjectIdSubProjectIdRouteWithChildren;
  AuthProjectTasksProjectIdSubProjectIdRoute: typeof AuthProjectTasksProjectIdSubProjectIdRoute;
  AuthProjectBidProjectIdIndexRoute: typeof AuthProjectBidProjectIdIndexRoute;
  AuthProjectImportProjectIdSubProjectIdLinkRoute: typeof AuthProjectImportProjectIdSubProjectIdLinkRoute;
}

const AuthProjectRouteChildren: AuthProjectRouteChildren = {
  AuthProjectProjectIdSubProjectIdExportQuoteRoute:
    AuthProjectProjectIdSubProjectIdExportQuoteRoute,
  AuthProjectProjectIdSubProjectIdSdpRoute:
    AuthProjectProjectIdSubProjectIdSdpRoute,
  AuthProjectProjectIdSubProjectIdSdpConfigRoute:
    AuthProjectProjectIdSubProjectIdSdpConfigRoute,
  AuthProjectBidRowDetailsProjectIdSubProjectIdRoute:
    AuthProjectBidRowDetailsProjectIdSubProjectIdRouteWithChildren,
  AuthProjectBidProjectIdSubProjectIdRoute:
    AuthProjectBidProjectIdSubProjectIdRoute,
  AuthProjectImportProjectIdSubProjectIdRoute:
    AuthProjectImportProjectIdSubProjectIdRoute,
  AuthProjectIndirectCostsProjectIdSubProjectIdRoute:
    AuthProjectIndirectCostsProjectIdSubProjectIdRoute,
  AuthProjectMarginOptimizationProjectIdSubProjectIdRoute:
    AuthProjectMarginOptimizationProjectIdSubProjectIdRouteWithChildren,
  AuthProjectPurchasesProjectIdSubProjectIdRoute:
    AuthProjectPurchasesProjectIdSubProjectIdRouteWithChildren,
  AuthProjectSummaryProjectIdSubProjectIdRoute:
    AuthProjectSummaryProjectIdSubProjectIdRoute,
  AuthProjectSupplierQuoteRequestProjectIdSubProjectIdRoute:
    AuthProjectSupplierQuoteRequestProjectIdSubProjectIdRouteWithChildren,
  AuthProjectTasksProjectIdSubProjectIdRoute:
    AuthProjectTasksProjectIdSubProjectIdRoute,
  AuthProjectBidProjectIdIndexRoute: AuthProjectBidProjectIdIndexRoute,
  AuthProjectImportProjectIdSubProjectIdLinkRoute:
    AuthProjectImportProjectIdSubProjectIdLinkRoute,
};

const AuthProjectRouteWithChildren = AuthProjectRoute._addFileChildren(
  AuthProjectRouteChildren,
);

interface AuthRouteChildren {
  AuthDealRoute: typeof AuthDealRouteWithChildren;
  AuthFrameRoute: typeof AuthFrameRouteWithChildren;
  AuthOrganisationRoute: typeof AuthOrganisationRouteWithChildren;
  AuthProjectRoute: typeof AuthProjectRouteWithChildren;
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthDealRoute: AuthDealRouteWithChildren,
  AuthFrameRoute: AuthFrameRouteWithChildren,
  AuthOrganisationRoute: AuthOrganisationRouteWithChildren,
  AuthProjectRoute: AuthProjectRouteWithChildren,
};

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren);

interface No_authRouteChildren {
  No_authResetPasswordRoute: typeof No_authResetPasswordRoute;
  No_authSignInRoute: typeof No_authSignInRoute;
  No_authSignUpRoute: typeof No_authSignUpRoute;
  No_authSsoErrorSplatRoute: typeof No_authSsoErrorSplatRoute;
}

const No_authRouteChildren: No_authRouteChildren = {
  No_authResetPasswordRoute: No_authResetPasswordRoute,
  No_authSignInRoute: No_authSignInRoute,
  No_authSignUpRoute: No_authSignUpRoute,
  No_authSsoErrorSplatRoute: No_authSsoErrorSplatRoute,
};

const No_authRouteWithChildren =
  No_authRoute._addFileChildren(No_authRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  No_authRoute: No_authRouteWithChildren,
  MagicLinkRoute: MagicLinkRoute,
  OnboardingRoute: OnboardingRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
